
// Copyright (c) 2020, Roman Morawek. All rights reserved.
// Auto-generated by locale_combine.js
// Author: Roman Morawek

export interface ILocaleLanguage {
  [key: string]: string;
}

export interface ILocale {
  [key: string]: ILocaleLanguage;
}

const LOCALES: ILocale = {
  "en": {
    "Electrical": "Electrical",
    "Water": "Water",
    "Gas": "Gas",
    "thisperiod_": "none",
    "thisperiod_day": "today",
    "thisperiod_week": "this week",
    "thisperiod_month": "this month",
    "thisperiod_year": "this year",
    "thisperiod_custom": "custom",
    "thisperiod_all": "all",
    "TimePeriod_": "none",
    "TimePeriod_day": "day",
    "TimePeriod_week": "week",
    "TimePeriod_month": "month",
    "TimePeriod_year": "year",
    "TimePeriod_all": "all",
    "TimePeriod_custom": "custom",
    "Period_none": "none",
    "Period_hour": "hour",
    "Period_day": "day",
    "Period_month": "month",
    "Period_year": "year",
    "FilterPeriod_day": "today",
    "FilterPeriod_month": "this month",
    "FilterPeriod_year": "this year",
    "FilterPeriod_last_day": "yesterday",
    "FilterPeriod_last_month": "last month",
    "FilterPeriod_last_year": "last year",
    "AutoexportPeriod_none": "disabled",
    "AutoexportPeriod_day": "daily",
    "AutoexportPeriod_month": "monthly",
    "AutoexportPeriod_year": "yearly",
    "ReportFormat_xlsx": "Microsoft Excel (.xlsx)",
    "ReportFormat_xls": "Microsoft Excel (.xls)",
    "ReportFormat_ods": "OpenDocument Spreadsheet (.ods)",
    "ReportFormat_csv": "Comma Separated Values (.csv)",
    "ReportFormat_txt": "Tab Separated Values (.txt)",
    "ReportFormat_html": "HTML Tables (.html)",
    "ReportFormat_rtf": "Rich Text Format (.ŕtf)",
    "ReportCSVDelimiter_,": ", [Comma]",
    "ReportCSVDelimiter_;": "; [Semicolon]",
    "ReportCSVDelimiter_\t": "  [Tab]",
    "ReportCSVDelimiter_|": "| [Pipe]",
    "userrole_": "userrole_",
    "userrole_viewer": "Normal user",
    "userrole_admin": "Administrator",
    "userrole_root": "root",
    "DeviceType_embyt-strato": "enline CC",
    "DeviceType_LIOB-586": "SMART-586",
    "DeviceType_LINX-153": "EMS-153",
    "DeviceType_LINX-120": "EMS-120",
    "DeviceType_virtual": "Virtual",
    "DeviceType_embyt-pc": "PC",
    "DeviceType_cloud": "Cloud Controller",
    "TrendMember_costs": "Costs",
    "TrendMember_energy": "Energy",
    "TrendMember_power": "Power",
    "TrendingColumn_tariff_energy": "energy per tariff",
    "TrendingColumn_energy": "energy",
    "TrendingColumn_max_energy": "maximum period energy",
    "TrendingColumn_target_value": "target value",
    "TrendingColumn_max_power": "maximum current power",
    "TrendingColumn_tariff_cost": "costs per tariff",
    "TrendingColumn_cost": "energy costs",
    "TrendingColumn_peak_cost": "peak costs",
    "TrendingColumn_energymeter": "energy meter value",
    "TrendingColumn_energy_max": "energy maximum",
    "TrendingColumn_energy_avg": "energy average",
    "TrendingColumn_energy_min": "energy minimum",
    "ChargerColumn_energy": "energy",
    "ChargerColumn_duration": "duration",
    "ChargerColumn_rfid": "RFID card",
    "ChargerColumn_user": "RFID user",
    "ChargerColumn_vehicle": "vehicle",
    "ChargerColumn_charger": "charging station",
    "ChargerColumn_connector": "charger connector",
    "ChargerColumn_meter_value": "start meter value",
    "ChargerColumn_stop_meter_value": "stop meter value",
    "ChargerColumn_costs": "costs",
    "ChargerColumn_tariff": "tariff",
    "ChargerColumn_stop_reason": "charging stop reason",
    "ChargerColumn_category": "category",
    "ChargerColumn_additional_data": "additional data",
    "chargingstate_0": "not ready",
    "chargingstate_1": "idle",
    "chargingstate_2": "charging",
    "chargingstate_3": "stopped",
    "chargingstate_4": "error",
    "chargingstate_5": "car stopped",
    "plugstate_0": "no cable",
    "plugstate_1": "cable in charger",
    "plugstate_2": "cable in charger and car",
    "AlarmSource_NVAlarm_Targetvalue": "Target Value Exceeded",
    "AlarmSource_NVAlarm_Restart": "System Restart",
    "AlarmSource_NVAlarm_MissingSync": "Missing Sync Pulse",
    "AlarmSource_NVAlarm_EnergyMeter": "Energy Meter Error",
    "AlarmSource_NVAlarm_Modul": "IO Module Error",
    "AlarmSource_NVAlarm_ManualActive": "IO Override Active",
    "AlarmSource_NVAlarm_LINX": "Controller Error",
    "AlarmSource_Cloud_Offline": "Site Offline",
    "AlarmSource_Cloud_TrendMonitor": "Trend Monitor Exceeded",
    "AlarmSource_Cloud_ChargerOffline": "Charger Offline",
    "AlarmSource_Cloud_ChargerFaulted": "Charger Faulted",
    "AlarmSource_Cloud_ChargingInterrupted": "Charging Interrupted",
    "ChargerModel_0": "Other",
    "ChargerModel_1": "Bender",
    "ChargerModel_2": "go-e",
    "ChargerModel_3": "PCE",
    "ChargerModel_4": "Keba",
    "ChargerModel_5": "Etrel",
    "ChargerModel_6": "Circontrol",
    "ChargerModel_7": "OCPP",
    "ChargerModel_8": "Salia",
    "ChargerStatus_": "Offline",
    "ChargerStatus_Available": "Available",
    "ChargerStatus_Preparing": "Preparing",
    "ChargerStatus_Charging": "Charging",
    "ChargerStatus_SuspendedEV": "Suspended car",
    "ChargerStatus_SuspendedEVSE": "Suspended station",
    "ChargerStatus_Finishing": "Finishing",
    "ChargerStatus_Reserved": "Reserved",
    "ChargerStatus_Unavailable": "Unavailable",
    "ChargerStatus_Faulted": "Faulted",
    "StopReason_": "Unknown",
    "StopReason_DeAuthorized": "Not authorized",
    "StopReason_EmergencyStop": "Emergency stop",
    "StopReason_EVDisconnected": "Cable disconnected",
    "StopReason_HardReset": "Hard reset",
    "StopReason_Local": "Locally stopped by user",
    "StopReason_Other": "Other",
    "StopReason_PowerLoss": "Loss of power",
    "StopReason_Reboot": "Charger reboot",
    "StopReason_Remote": "Remotely stopped or expired",
    "StopReason_SoftReset": "Soft reset",
    "StopReason_UnlockCommand": "Central system unlock",
    "StopReason_Unauthenticated": "No authorization",
    "StopReason_NotEnded": "End of session not detected",
    "StopReason_SessionEnd": "-",
    "OcppCmdStatus_": "Unknown",
    "OcppCmdStatus_none": "No command pending.",
    "OcppCmdStatus_new": "Triggering command.",
    "OcppCmdStatus_issued": "Sending command.",
    "OcppCmdStatus_sent": "Executing command.",
    "OcppCmdStatus_confirmed": "Command executed.",
    "ChargingMode_early": "as soon as possible",
    "ChargingMode_late": "as late as possible",
    "ChargingMode_uniform": "uniform low",
    "ChargingMode_costOptimized": "ecological",
    "ChargingMode_pvOptimized": "PV-optimized",
    "DashboardPanel_": "<automatic>",
    "DashboardPanel_empty": "<empty>",
    "DashboardPanel_Alarms": "Alarms",
    "DashboardPanel_EMobility": "E-Mobility",
    "DashboardPanel_Energy": "Trend Data",
    "DashboardPanel_Inputs": "Inputs",
    "DashboardPanel_Monitor": "Monitor",
    "DashboardPanel_Outputs": "Outputs",
    "DashboardPanel_Power": "Power",
    "DashboardPanel_Reports": "Reports",
    "DashboardPanel_SiteInfos": "Site Infos",
    "DashboardPanel_TrendMonitor": "Trend Monitor",
    "Rfid_LimitEnergyPeriod_---": "---",
    "Rfid_LimitEnergyPeriod_DAY": "Day",
    "Rfid_LimitEnergyPeriod_MONTH": "Month",
    "Rfid_LimitEnergyPeriod_YEAR": "Year",
    "Create": "Create",
    "SignUp": "SignUp",
    "User exists already!": "User exists already!",
    "Incorrect username or password.": "Incorrect username or password.",
    "oldPassword and newPassword are required to changePassword": "Old and New password are required to change your password.",
    "Password did not conform with policy: Password not long enough": "New password not long enough.",
    "Attempt limit exceeded, please try after some time.": "Attempt limit exceeded, please try after some time.",
    "ImporterStatus_": "Unknown",
    "ImporterStatus_initial": "Initiated",
    "ImporterStatus_received": "Processing",
    "ImporterStatus_processed": "Done",
    "ImporterStatus_error": "Error",
    "ImporterStatus_upload_failed": "Upload Failed",
    "ImporterStatus_import_failed": "Import Failed",
    "ImporterFileType_TrendData": "Trend data",
    "ImporterFileType_EDA": "EDA",
    "ImporterFileType_EVU": "EVU",
    "ImporterFileTypes_EVU": "Load curve data",
    "ImporterFileTypes_EDA": "EDA data",
    "DeletionStrategy_small": "Deletion Model Small",
    "DeletionStrategy_large": "Deletion Model Large",
    "DeletionStrategy_unlimited": "Deletion Model Unlimited",
    "Acknowledge": "Acknowledge",
    "active": "active",
    "pending": "pending",
    "active, acknowledged": "active, acknowledged",
    "acknowledged": "acknowledged",
    "acknowledge this alarm and older alarms of same type": "acknowledge this alarm and older alarms of same type",
    "Enabled": "Enabled",
    "yes": "yes",
    "no": "no",
    "Alarm Settings": "Alarm Settings",
    "Activated Alarms": "Activated Alarms",
    "enabled": "enabled",
    "disabled": "disabled",
    "Timeout": "Timeout",
    "hour(s)": "hour(s)",
    "Email Notifications": "Email Notifications",
    "Email Address": "Email Address",
    "SoC": "SoC",
    "Changing password...": "Changing password...",
    "Checking sign-up...": "Checking sign-up...",
    "Checking login...": "Checking login...",
    "Loading site list...": "Loading site list...",
    "Error loading parameters.": "Error loading parameters.",
    "Loading parameters...": "Loading parameters...",
    "Loading site data...": "Loading site data...",
    "All categories": "All categories",
    "Without mapping": "Without mapping",
    "Select category": "Select category",
    "Charger Status": "Charger Status",
    "Offline": "Offline",
    "Connector Status": "Connector Status",
    "Energymeter": "Energymeter",
    "Voltage": "Voltage",
    "Charging Power": "Charging Power",
    "Charging Current": "Charging Current",
    "Energy Session": "Energy Session",
    "show all charging sessions": "show all charging sessions",
    "No chargers present.": "No chargers present.",
    "Connector": "Connector",
    "Search for chargers...": "Search for chargers...",
    "Search for charger name, vendor or serial number. To search for multiple fields, separate search texts by a space!": "Search for charger name, vendor or serial number. To search for multiple fields, separate search texts by a space!",
    "Vendor": "Vendor",
    "Model": "Model",
    "Software": "Software",
    "Serial Number": "Serial Number",
    "Last Data": "Last Data",
    "Charging authentication": "Charging authentication",
    "Authorized": "Authorized",
    "Public": "Public",
    "Charger index": "Charger index",
    "Suspended": "Suspended",
    "change settings": "change settings",
    "print": "print",
    "Charging Control": "Charging Control",
    "Save": "Save",
    "Limit power": "Limit power",
    "Limit the power to": "Limit the power to",
    "Please notice that a minimum charging power exists that cannot be fallen below. The resulting charging power might be increased.": "Please notice that a minimum charging power exists that cannot be fallen below. The resulting charging power might be increased.",
    "Limit energy": "Limit energy",
    "Limit the energy to": "Limit the energy to",
    "Already charged:": "Already charged:",
    "Charging Strategy": "Charging Strategy",
    "Charge immediately and stop after requested energy is reached.": "Charge immediately and stop after requested energy is reached.",
    "Charge as late as possible to match requested energy and departure time.": "Charge as late as possible to match requested energy and departure time.",
    "Charge with least possible power to match requested energy and departure time. Please notice that a minimum charging power exists that cannot be fallen below.": "Charge with least possible power to match requested energy and departure time. Please notice that a minimum charging power exists that cannot be fallen below.",
    "Charge in those periods where the energy prices (EPEX Spot) are lowest. This is cost optimal if you have a variable energy price and environmental friendly as it uses off-peak periods.": "Charge in those periods where the energy prices (EPEX Spot) are lowest. This is cost optimal if you have a variable energy price and environmental friendly as it uses off-peak periods.",
    "Charge in those periods where Photo Voltaic power is maximum during the period until the departure time.": "Charge in those periods where Photo Voltaic power is maximum during the period until the departure time.",
    "Automatically activate this charging strategy for new charging sessions": "Automatically activate this charging strategy for new charging sessions",
    "Please notice that if you limit both, the power and the energy, the resulting lower charging limit will be used.": "Please notice that if you limit both, the power and the energy, the resulting lower charging limit will be used.",
    "Departure time": "Departure time",
    "Charging Progress": "Charging Progress",
    "charging power": "charging power",
    "tariff": "tariff",
    "MMM d": "MMM d",
    "h a": "h a",
    "h:mm a": "h:mm a",
    "Conditions": "Conditions",
    "Name": "Name",
    "Value": "Value",
    "No conditions present.": "No conditions present.",
    "Search for condition...": "Search for condition...",
    "OK": "OK",
    "Cancel": "Cancel",
    "Unsaved Changes": "Unsaved Changes",
    "There are unsaved changes! On OK you confirm reverting the changes. Press Cancel if you want to save your changes.": "There are unsaved changes! On OK you confirm reverting the changes. Press Cancel if you want to save your changes.",
    "Select control circuit": "Select control circuit",
    "Energy [kWh]": "Energy [kWh]",
    "No option available": "No option available",
    "Select All": "Select All",
    "Chargers": "Chargers",
    "Charging Cards": "Charging Cards",
    "Select E-Mobility info": "Select E-Mobility info",
    "Failed to load data.": "Failed to load data.",
    "No data available. Try reset zooming.": "No data available. Try reset zooming.",
    "Please select tariff circuit.": "Please select tariff circuit.",
    "No data available.": "No data available.",
    "reset zoom": "reset zoom",
    "Energy Meters": "Energy Meters",
    "Module": "Module",
    "Energy Source": "Energy Source",
    "Number": "Number",
    "No energy meters present.": "No energy meters present.",
    "Back to Power View": "Back to Power View",
    "Search for energy meter...": "Search for energy meter...",
    "All energy sources": "All energy sources",
    "Select energy source": "Select energy source",
    "Only .xlsx files are supported for import!": "Only .xlsx files are supported for import!",
    "Only 1 file at once allowed on import!": "Only 1 file at once allowed on import!",
    "Import data from file": "Import data from file",
    "Drop file here or": "Drop file here or",
    "click to upload": "click to upload",
    "All hierarchies": "All hierarchies",
    "Root": "Root",
    "Select hierarchy": "Select hierarchy",
    "Hierarchy Up": "Hierarchy Up",
    "File upload failed. Please try again.": "File upload failed. Please try again.",
    "File import failed. Please try again.": "File import failed. Please try again.",
    "Refresh": "Refresh",
    "Status": "Status",
    "Uploaded on": "Uploaded on",
    "Info": "Info",
    "Duration": "Duration",
    "Select type of import": "Select type of import",
    "Select tariff circuit (import destination)": "Select tariff circuit (import destination)",
    "File upload started. Please wait.": "File upload started. Please wait.",
    "Import load curve data": "Import load curve data",
    "Imported data will replace (delete!) data with the same timestamp!": "Imported data will replace (delete!) data with the same timestamp!",
    "The file must be in the following format:": "The file must be in the following format:",
    "Cloumn header for the timestamps: 'Zeitpunkt'": "Cloumn header for the timestamps: 'Zeitpunkt'",
    "The next column after the timestamp column must contain the power values in kW": "The next column after the timestamp column must contain the power values in kW",
    "The timestamps are in Central European (Summer) Time (CET and CEST)": "The timestamps are in Central European (Summer) Time (CET and CEST)",
    "This corresponds to the enline trend report 'EVU Format' with 'maximum period energy', the grouping 'date, then tariff circuit', aggregation 'none', filtered by exactly one tariff circuit, and output format 'Microsoft Excel (.xlsx)'.": "This corresponds to the enline trend report 'EVU Format' with 'maximum period energy', the grouping 'date, then tariff circuit', aggregation 'none', filtered by exactly one tariff circuit, and output format 'Microsoft Excel (.xlsx)'.",
    "Alternatively the file can be formatted in some typical EVU format; ": "Alternatively the file can be formatted in some typical EVU format; ",
    "the following link provides an example of such a file: ": "the following link provides an example of such a file: ",
    "Import EDA data": "Import EDA data",
    "The file must be in the format of 'EDA Energiedatenreport'.": "The file must be in the format of 'EDA Energiedatenreport'.",
    "The importer will search in the current site for a tariff circuit with exactly one associated energy meter which has the same number as one of the MeteringpointIDs. If found, data is imported to that tariff circuit. This procedure is repeated for each MeteringpointID found in the EDA file.": "The importer will search in the current site for a tariff circuit with exactly one associated energy meter which has the same number as one of the MeteringpointIDs. If found, data is imported to that tariff circuit. This procedure is repeated for each MeteringpointID found in the EDA file.",
    "Select Tariff Circuit": "Select Tariff Circuit",
    "Select Import Type": "Select Import Type",
    "No Info": "No Info",
    "tariff circuit(s) imported": "tariff circuit(s) imported",
    "tariff circuit not found": "tariff circuit not found",
    "Upload failed": "Upload failed",
    "Import failed": "Import failed",
    "change value": "change value",
    "Inputs": "Inputs",
    "No inputs present.": "No inputs present.",
    "Search for inputs...": "Search for inputs...",
    "On": "On",
    "Off": "Off",
    "Timestamp": "Timestamp",
    "New State": "New State",
    "Activities": "Activities",
    "Off Time": "Off Time",
    "On Time": "On Time",
    "The number of input/output trend data items is very high.": "The number of input/output trend data items is very high.",
    "Therefore the data table might be truncated and not complete.": "Therefore the data table might be truncated and not complete.",
    "Mixed": "Mixed",
    "Data loading...": "Data loading...",
    "Pending sign-up confirmation.": "Pending sign-up confirmation.",
    "User already exists - try to login.": "User already exists - try to login.",
    "This email address is not allowed to sign-up.": "This email address is not allowed to sign-up.",
    "Please contact your administrator.": "Please contact your administrator.",
    "Code has expired - request a new one.": "Code has expired - request a new one.",
    "Code not valid - request a new one.": "Code not valid - request a new one.",
    "Password does not meet minimum requirements on length and complexity.": "Password does not meet minimum requirements on length and complexity.",
    "You are already confirmed - try to login.": "You are already confirmed - try to login.",
    "Confirmation failed - please try again.": "Confirmation failed - please try again.",
    "Email missing - please enter your email.": "Email missing - please enter your email.",
    "Password missing - please enter your password.": "Password missing - please enter your password.",
    "Confirmation code missing - please enter the code.": "Confirmation code missing - please enter the code.",
    "Unknown error: ": "Unknown error: ",
    "Login failed.": "Login failed.",
    "Changing password failed.": "Changing password failed.",
    "Failed": "Failed",
    "Unknown": "Unknown",
    "Input(s)": "Input(s)",
    "Output(s)": "Output(s)",
    "Energy Meter(s)": "Energy Meter(s)",
    "Modules": "Modules",
    "Type": "Type",
    "Address": "Address",
    "Usage": "Usage",
    "Comment": "Comment",
    "No modules present.": "No modules present.",
    "Search for module...": "Search for module...",
    "Target": "Target",
    "Trend": "Trend",
    "Cummulated Power": "Cummulated Power",
    "Trended Power": "Trended Power",
    "Target Value": "Target Value",
    "Period Runtime": "Period Runtime",
    "Current Power": "Current Power",
    "Control Level": "Control Level",
    "Chargepoint-ID": "Chargepoint-ID",
    "Connectors": "Connectors",
    "Authentication": "Authentication",
    "charging is only allowed to valid RFID cards": "charging is only allowed to valid RFID cards",
    "charging is only allowed to everyone": "charging is only allowed to everyone",
    "Stop Charging": "Stop Charging",
    "Unlock Connector": "Unlock Connector",
    "Authorize Charging": "Authorize Charging",
    "Reboot Charger": "Reboot Charger",
    "Timeout Error": "Timeout Error",
    "Stopping charging session": "Stopping charging session",
    "This will stop the ongoing charging session. Are you sure?": "This will stop the ongoing charging session. Are you sure?",
    "Unlocking connector": "Unlocking connector",
    "This will stop the ongoing charging session and unlock the charging connector. Are you sure?": "This will stop the ongoing charging session and unlock the charging connector. Are you sure?",
    "Resetting charging session": "Resetting charging session",
    "This will trigger a reset of the charging session. Are you sure?": "This will trigger a reset of the charging session. Are you sure?",
    "analog": "analog",
    "control value": "control value",
    "override": "override",
    "Outputs": "Outputs",
    "No outputs present.": "No outputs present.",
    "Search for outputs...": "Search for outputs...",
    "Select period": "Select period",
    "Select Date": "Select Date",
    "Start Date": "Start",
    "End Date": "End",
    "switch to hierarchy view": "switch to hierarchy view",
    "switch to sankey view": "switch to sankey view",
    "switch to pie-chart view": "switch to pie-chart view",
    "switch to list view": "switch to list view",
    "highlight tariffs circuits...": "highlight tariffs circuits...",
    "internal error...": "internal error...",
    "Refused Charging Cards": "Refused Charging Cards",
    "Card Number": "Card Number",
    "Charger": "Charger",
    "First Attempt": "First Attempt",
    "Last Attempt": "Last Attempt",
    "Counter": "Counter",
    "No refused charging cards detected within the last 7 days.": "No refused charging cards detected within the last 7 days.",
    "add this as new charging card": "add this as new charging card",
    "View Report Online": "View Report Online",
    "Update Report File": "Update Report File",
    "Create Report File": "Create Report File",
    "Download": "Download",
    "Report generation timed out. Try reducing report content.": "Report generation timed out. Try reducing report content.",
    "generating report": "generating report",
    "Card number": "Card number",
    "all chargers": "all chargers",
    "Valid from": "Valid from",
    "Valid until": "Valid until",
    "Energy/Cost limit": "Energy/Cost limit",
    "Last Usage": "Last Usage",
    "Never": "Never",
    "used energy and costs exclude ongoing charging sessions": "used energy and costs exclude ongoing charging sessions",
    "No charging card with active charging session found.": "No charging card with active charging session found.",
    "No charging card found.": "No charging card found.",
    "Charging since": "Charging since",
    "Search for cards...": "Search for cards...",
    "Search for cards-numbers, names or categories. To search for multiple fields, separate search texts by a space!": "Search for cards-numbers, names or categories. To search for multiple fields, separate search texts by a space!",
    "Too many active charging cards (>150).": "Too many active charging cards (>150).",
    "Displaying of additional details and editing of charging cards is not possible.": "Displaying of additional details and editing of charging cards is not possible.",
    "Card data not fully loaded yet.": "Card data not fully loaded yet.",
    "If this persists, please reduce the number of active charging cards.": "If this persists, please reduce the number of active charging cards.",
    "No charging cards added yet.": "No charging cards added yet.",
    "Show Inactive": "Show Inactive",
    "New Charging Card": "New Charging Card",
    "Delete Inactive Cards": "Delete Inactive Cards",
    "Category": "Category",
    "Validity": "Validity",
    "Energy Limit": "Energy Limit",
    "edit charging card": "edit charging card",
    "link charging card": "link charging card",
    "delete charging card": "delete charging card",
    "the energy and cost limits exclude ongoing charging sessions": "the energy and cost limits exclude ongoing charging sessions",
    "Deleting charging card": "Deleting charging card",
    "This will delete this charging card. The charging data itself will still be available. Are you sure?": "This will delete this charging card. The charging data itself will still be available. Are you sure?",
    "This will delete all inactive charging cards of the list. Are you sure?": "This will delete all inactive charging cards of the list. Are you sure?",
    "The number of active charging cards exceeds the limit. Please delete some cards to be able to create new cards.": "The number of active charging cards exceeds the limit. Please delete some cards to be able to create new cards.",
    "Available": "Available",
    "Charging": "Charging",
    "Expired": "Expired",
    "Data modified.": "Data modified.",
    "Saving data...": "Saving data...",
    "Sucessfully saved data.": "Sucessfully saved data.",
    "Saving data failed": "Saving data failed",
    "Saving data failed.": "Saving data failed.",
    "Database Policy": "Database Policy",
    "End Customer": "End Customer",
    "Order Number": "Order Number",
    "Service Type": "Service Type",
    "Comments": "Comments",
    "Select deletion strategy": "Select deletion strategy",
    "No site information available!": "No site information available!",
    "Current Site": "Current Site",
    "None": "None",
    "Tariff": "Tariff",
    "Priority": "Priority",
    "Site tariffs are used.": "Site tariffs are used.",
    "Add Tariff": "Add Tariff",
    "Select Tariff": "Select Tariff",
    "No more tariffs available.": "No more tariffs available.",
    "Select tariff": "Select tariff",
    "remove tariff from this charging card": "remove tariff from this charging card",
    "save tariff to this charging card": "save tariff to this charging card",
    "related to: ": "related to: ",
    "Parent": "Parent",
    "No tariff circuits present.": "No tariff circuits present.",
    "Select tariff circuit": "Select tariff circuit",
    "No tariff available": "No tariff available",
    "All tariff circuits": "All tariff circuits",
    "all": "all",
    "items selected": "items selected",
    "New Tariff": "New Tariff",
    "New Site Tariff": "New Site Tariff",
    "Add Global Tariff": "Add Global Tariff",
    "Cost Tariffs": "Cost Tariffs",
    "Cost per Energy": "Cost per Energy",
    "Cost per Period": "Cost per Period",
    "Time Restriction": "Time Restriction",
    "No tariff added yet.": "No tariff added yet.",
    "edit tariff": "edit tariff",
    "delete tariff": "delete tariff",
    "Delete cost tariff": "Delete cost tariff",
    "This will delete this tariff. All associated costs will be lost. Are you sure?": "This will delete this tariff. All associated costs will be lost. Are you sure?",
    "Tariffcircuit": "Tariffcircuit",
    "Period": "Period",
    "Energy": "Energy",
    "Costs Energy": "Costs Energy",
    "Power": "Power",
    "Sum / Max": "Sum / Max",
    "switch to graph view": "switch to graph view",
    "Select data": "Select data",
    "Current data": "Current data",
    "Limit value": "Limit value",
    "Alarm limit": "Alarm limit",
    "Overshoot": "Overshoot",
    "Select trend monitor": "Select trend monitor",
    "Complete user data": "Complete user data",
    "Modify current user": "Modify current user",
    "Full name": "Full name",
    "Email": "Email",
    "User name needed!": "User name needed!",
    "Old password": "Old password",
    "Password needed": "Password needed",
    "New password": "New password",
    "Passwords are different": "Passwords are different",
    "Verify new password": "Verify new password",
    "Finish User Setup": "Finish User Setup",
    "Change Password": "Change Password",
    "Changing User": "Changing User",
    "The two fields for the new password do not match.": "The two fields for the new password do not match.",
    "Please enter the same password twice.": "Please enter the same password twice.",
    "Reset Password": "Reset Password",
    "We've send an email with an verification code to your email address.": "We've send an email with an verification code to your email address.",
    "Please enter that code in the inut box and choose and verify your new password.": "Please enter that code in the inut box and choose and verify your new password.",
    "You can request a verification code to be sent to your email address of your account.": "You can request a verification code to be sent to your email address of your account.",
    "Afterwards you can enter the received verification code here together with a new password.": "Afterwards you can enter the received verification code here together with a new password.",
    "Check your Email Address": "Check your Email Address",
    "Verification Code": "Verification Code",
    "Verify password": "Verify password",
    "Request Verification Code": "Request Verification Code",
    "Request New Code": "Request New Code",
    "Resend Code...": "Resend Code...",
    "Requesting verification code failed.": "Requesting verification code failed.",
    "Please enter the code you received via email": "Please enter the code you received via email",
    "together with your password...": "together with your password...",
    "below...": "below...",
    "Not your email?": "Not your email?",
    "New Password": "New Password",
    "Check your Password": "Check your Password",
    "Verify new Password": "Verify new Password",
    "Confirmation Code": "Confirmation Code",
    "Password": "Password",
    "Confirm": "Confirm",
    "Dashboard": "Dashboard",
    "Monitor": "Monitor",
    "nav_Trend Data": "Trend Data",
    "Trend Monitor": "Trend Monitor",
    "Reports": "Reports",
    "Public Display": "Public Display",
    "Current Status": "Current Status",
    "Input/Outputs": "Input/Outputs",
    "IO Graph": "IO Graph",
    "E-Mobility": "E-Mobility",
    "Energy Management Chargers": "Energy Management Chargers",
    "Configuration": "Configuration",
    "Charging Sessions": "Charging Sessions",
    "Active Session": "Active Session",
    "Alarms": "Alarms",
    "Device": "Device",
    "by Energie-Plan + Management GmbH": "by Energie-Plan + Management GmbH",
    "offline": "offline",
    "view user": "view user",
    "view site": "view site",
    "view controller settings": "view controller settings",
    "Add Global or Removed Tariff": "Add Global or Removed Tariff",
    "No global tariffs available": "No global tariffs available",
    "add this global tariff to site": "add this global tariff to site",
    "Charger Settings": "Charger Settings",
    "Delete Charger": "Delete Charger",
    "restricted charging": "restricted charging",
    "charging always allowed": "charging always allowed",
    "Charger name": "Charger name",
    "Location": "Location",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "Paste from Clipboard": "Paste from Clipboard",
    "EVSE-ID": "EVSE-ID",
    "Plug": "Plug",
    "Phases": "Phases",
    "DC": "DC",
    "select charging authentication": "select charging authentication",
    "Delete charger": "Delete charger",
    "This will delete this charger. All past charging sessions and charging data will be lost. Are you sure?": "This will delete this charger. All past charging sessions and charging data will be lost. Are you sure?",
    "Invalid Coordinates": "Invalid Coordinates",
    "Invalid coordinate values. Latitude must be between -90 and 90, longitude between -180 and 180.": "Invalid coordinate values. Latitude must be between -90 and 90, longitude between -180 and 180.",
    "Invalid coordinate format. Please use format: latitude, longitude (e.g., 48.203951, 16.402388)": "Invalid coordinate format. Please use format: latitude, longitude (e.g., 48.203951, 16.402388)",
    "Clipboard Error": "Clipboard Error",
    "Failed to read from clipboard. Please ensure your browser supports clipboard access.": "Failed to read from clipboard. Please ensure your browser supports clipboard access.",
    "Input Settings": "Input Settings",
    "Switch": "Switch",
    "Changing the settings of this input item:": "Changing the settings of this input item:",
    "Old value": "Old value",
    "New value": "New value",
    "Select value": "Select value",
    "Output Settings": "Output Settings",
    "Unknown/Offline": "Unknown/Offline",
    "Turn to Override Off": "Turn to Override Off",
    "Turn to Override On": "Turn to Override On",
    "Switch Off": "Switch Off",
    "Switch On": "Switch On",
    "Changing the settings of this output item:": "Changing the settings of this output item:",
    "Current Value": "Current Value",
    "Override": "Override",
    "Command": "Command",
    "The new command will be executed immediately.": "The new command will be executed immediately.",
    "Report Settings": "Report Settings",
    "Trend Report": "Trend Report",
    "Charging Report": "Charging Report",
    "Input/Output Report": "Input/Output Report",
    "Site Report": "Site Report",
    "Title": "Title",
    "Activated": "Activated",
    "Delete Report": "Delete Report",
    "IOs": "IOs",
    "Sites": "Sites",
    "EVU Format": "EVU Format",
    "Data": "Data",
    "Group By": "Group By",
    "Aggregation": "Aggregation",
    "Reference": "Reference",
    "no reference": "no reference",
    "other tariff circuit": "other tariff circuit",
    "previous time period": "previous time period",
    "Filter": "Filter",
    "hide zero data values": "hide zero data values",
    "tariff circuits": "tariff circuits",
    "start date": "start date",
    "end date": "end date",
    "period": "period",
    "Company": "Company",
    "Output Format": "Output Format",
    "Delimiter": "Delimiter",
    "Hide Sum Row": "Hide Sum Row",
    "Auto-Export": "Auto-Export",
    "recipient": "recipient",
    "new report": "new report",
    "custom name of report": "custom name of report",
    "press CTRL (CMD on Mac) key to select mutliple items": "press CTRL (CMD on Mac) key to select mutliple items",
    "email address for report receipt": "email address for report receipt",
    "none": "none",
    "date": "date",
    "tariff circuit": "tariff circuit",
    "then": "then",
    "charger": "charger",
    "charging card": "charging card",
    "Charging Card Links": "Charging Card Links",
    "Linked": "Linked",
    "Unlinked": "Unlinked",
    "Main site: ": "Main site: ",
    "Site Name": "Site Name",
    "Site Linked": "Site Linked",
    "unlink charging card": "unlink charging card",
    "Type to filter sites...": "Type to filter sites...",
    "Charging Card Settings": "Charging Card Settings",
    "Foreign Card": "Foreign Card",
    "Delete Card": "Delete Card",
    "Additional Data": "Additional Data",
    "Generate Pin": "Generate Pin",
    "Card restrictions": "Card restrictions",
    "Limit the card to these chargers": "Limit the card to these chargers",
    "Limit the card to chargers": "Limit the card to chargers",
    "Limit the card from": "Limit the card from",
    "Limit the card until": "Limit the card until",
    "Limit the total energy to": "Limit the total energy to",
    "every": "every",
    "Reset Counter": "Reset Counter",
    "Limit the total energy": "Limit the total energy",
    "Limit the total cost to": "Limit the total cost to",
    "Limit the total cost": "Limit the total cost",
    "Limit the charging power to": "Limit the charging power to",
    "Limit the charging power": "Limit the charging power",
    "Card access": "Card access",
    "Allow login with card": "Allow login with card",
    "Charger power control": "Charger power control",
    "Vehicle": "Vehicle",
    "Vehicle information": "Vehicle information",
    "Add vehicle information": "Add vehicle information",
    "Identifier": "Identifier",
    "Battery": "Battery",
    "Energy limit in kWh. You may also set a start date, which is also the start of energy metering for this limit or a period for which this limit applies.": "Energy limit in kWh. You may also set a start date, which is also the start of energy metering for this limit or a period for which this limit applies.",
    "This resets the counter for the used energy by setting the start date to the current timestamp.": "This resets the counter for the used energy by setting the start date to the current timestamp.",
    "Cost limit. You may also set a start date, which is also the start of this cost limit or a period for which this limit applies.": "Cost limit. You may also set a start date, which is also the start of this cost limit or a period for which this limit applies.",
    "Power limit in kW. You can restrict the maximum charging speed using this value.": "Power limit in kW. You can restrict the maximum charging speed using this value.",
    "Checking for valid charger card number...": "Checking for valid charger card number...",
    "This charger card number is not valid. It either does not fulfill requirements on card number or is already in use.": "This charger card number is not valid. It either does not fulfill requirements on card number or is already in use.",
    "Card number already in use.": "Card number already in use.",
    "Generate a valid Pin code for charging stations.": "Generate a valid Pin code for charging stations.",
    "Starting charging session": "Starting charging session",
    "Which user shall be associated to this charging session?": "Which user shall be associated to this charging session?",
    "This will start a new charging session and authorize the selected user.": "This will start a new charging session and authorize the selected user.",
    "Please make sure that the vehicle is ready and already plugged to the charger.": "Please make sure that the vehicle is ready and already plugged to the charger.",
    "Select user": "Select user",
    "Tariff Settings": "Tariff Settings",
    "Delete Tariff": "Delete Tariff",
    "Currency": "Currency",
    "If multiple tariffs apply, the tariff with highest priority will be used.": "If multiple tariffs apply, the tariff with highest priority will be used.",
    "Costs": "Costs",
    "Cost per energy": "Cost per energy",
    "Cost per period": "Cost per period",
    "Validity Period": "Validity Period",
    "Limit this tariff from": "Limit this tariff from",
    "Limit this tariff until": "Limit this tariff until",
    "The time restriction is:": "The time restriction is:",
    "The time restriction only applies to the start of the charging session. The whole session will be handled like its start.": "The time restriction only applies to the start of the charging session. The whole session will be handled like its start.",
    "Set a time restriction": "Set a time restriction",
    "Trend Settings": "Trend Settings",
    "Changing the values of this trend item:": "Changing the values of this trend item:",
    "Regulation Period": "Regulation Period",
    "Trend Monitor Settings": "Trend Monitor Settings",
    "Delete Trend Monitor": "Delete Trend Monitor",
    "Tariff Circuit": "Tariff Circuit",
    "value": "value",
    "Alarm Tolerance": "Alarm Tolerance",
    "Alarm Slope": "Alarm Slope",
    "new trend monitor": "new trend monitor",
    "custom name of trend monitor": "custom name of trend monitor",
    "the tolerance for the target value overshoot alarm": "the tolerance for the target value overshoot alarm",
    "the tolerance slope for the target value overshoot during the period": "the tolerance slope for the target value overshoot during the period",
    "Alarm": "Alarm",
    "Further Information": "Further Information",
    "No alarms pending.": "No alarms pending.",
    "Search for alarms...": "Search for alarms...",
    "Back to Charger List": "Back to Charger List",
    "Charger List": "Charger List",
    "Edit Charger": "Edit Charger",
    "Back to Session List": "Back to Session List",
    "Ongoing Charging Session": "Ongoing Charging Session",
    "Charging Session": "Charging Session",
    "Charging Data": "Charging Data",
    "RESTRICTED CHARGER": "RESTRICTED CHARGER",
    "Charger model": "Charger model",
    "User": "User",
    "Charging card": "Charging card",
    "Start": "Start",
    "Transaction ID": "Transaction ID",
    "End": "End",
    "ongoing": "ongoing",
    "Start meter value": "Start meter value",
    "End meter value": "End meter value",
    "Stop reason": "Stop reason",
    "Station": "Station",
    "Status Change Events": "Status Change Events",
    "Source": "Source",
    "Event": "Event",
    "Details": "Details",
    "power limit": "power limit",
    "No charging sessions were found.": "No charging sessions were found.",
    "Stop Reason": "Stop Reason",
    "User Filter": "User Filter",
    "refreshing list...": "refreshing list...",
    "Search failed.": "Search failed.",
    "Sum": "Sum",
    "disconnected": "disconnected",
    "refused": "refused",
    "expired": "expired",
    "other": "other",
    "Select Charger": "Select Charger",
    "Custom Dashboard is not configured for this site.": "Custom Dashboard is not configured for this site.",
    "Realtime Update": "Realtime Update",
    "Grid Export": "Grid Export",
    "Grid Import": "Grid Import",
    "Battery Storage": "Battery Storage",
    "Battery Charging": "Battery Charging",
    "Battery Discharging": "Battery Discharging",
    "Photovoltaic": "Photovoltaic",
    "Other": "Other",
    "Last": "Last",
    "Days": "Days",
    "Today": "Today",
    "Export": "Export",
    "Import": "Import",
    "No widget selected.": "No widget selected.",
    "Dashboard-Items": "Dashboard-Items",
    "Select Dashboard": "Select Dashboard",
    "Max. Power": "Max. Power",
    "Max. Current": "Max. Current",
    "Current": "Current",
    "Session": "Session",
    "State": "State",
    "locked": "locked",
    "User Administration": "User Administration",
    "Site List": "Site List",
    "Loading...": "Loading...",
    "Create User": "Create User",
    "Save Changes": "Save Changes",
    "Cancel and Back": "Cancel and Back",
    "Back to User Overview": "Back to User Overview",
    "User name": "User name",
    "Role": "Role",
    "Special access rights": "Special access rights",
    "Acknowledge Alarms": "Acknowledge Alarms",
    "activate/edit alarms": "activate/edit alarms",
    "Import Trend data": "Import Trend data",
    "Set Virtual Inputs": "Set Virtual Inputs",
    "Control Outputs": "Control Outputs",
    "Update Parameters": "Update Parameters",
    "OCPP Change Settings": "OCPP Change Settings",
    "RFIDs, tariffs, chargers public/private": "RFIDs, tariffs, chargers public/private",
    "OCPP Administrate Chargers": "OCPP Administrate Chargers",
    "delete charger, change connector names": "delete charger, change connector names",
    "OCPP Control Chargers": "OCPP Control Chargers",
    "start/stop transactions, unlock connector, reboot charger": "start/stop transactions, unlock connector, reboot charger",
    "access energy management charger data": "access energy management charger data",
    "Local Controller Admin": "Local Controller Admin",
    "show extended controller data (modules, conditions) and allow reboot": "show extended controller data (modules, conditions) and allow reboot",
    "create/edit/delete reports": "create/edit/delete reports",
    "Trend Monitors": "Trend Monitors",
    "create/edit/delete Trend Monitors": "create/edit/delete Trend Monitors",
    "Access": "Access",
    "Select role": "Select role",
    "Search for sites...": "Search for sites...",
    "Click here to see the list of modules and conditions": "Click here to see the list of modules and conditions",
    "Modules and Conditions": "Modules and Conditions",
    "Switches": "Switches",
    "Analog": "Analog",
    "Minimum": "Minimum",
    "Maximum": "Maximum",
    "Average": "Average",
    "No input/output available": "No input/output available",
    "Select input/output": "Select input/output",
    "Select analog/switch": "Select analog/switch",
    "Select data aggregation": "Select data aggregation",
    "TrendGraphTitle": "Trend",
    "TrendTimeGraphTitle": "Switching operations",
    "All items selected": "All items selected",
    "Controller Status": "Controller Status",
    "Date and Time": "Date and Time",
    "Software Version": "Software Version",
    "Cloud Status": "Cloud Status",
    "Disabled": "Disabled",
    "Connected": "Connected",
    "listener": "listener",
    "Disconnected": "Disconnected",
    "RS485 Bus Load, Controller Temperature": "RS485 Bus Load, Controller Temperature",
    "CPU Load / Free RAM / Free Storage": "CPU Load / Free RAM / Free Storage",
    "Reload Site": "Reload Site",
    "Reboot Controller": "Reboot Controller",
    "Power-Off Controller": "Power-Off Controller",
    "IP Configuration": "IP Configuration",
    "Hostname": "Hostname",
    "Current IP Addresses": "Current IP Addresses",
    "Mode": "Mode",
    "Static IP Address": "Static IP Address",
    "Netmask": "Netmask",
    "Default Gateway": "Default Gateway",
    "DNS Server": "DNS Server",
    "IP Settings": "IP Settings",
    "Other Configuration": "Other Configuration",
    "Operator Password": "Operator Password",
    "Repeat Operator Password": "Repeat Operator Password",
    "Cancel Edit": "Cancel Edit",
    "Edit Settings": "Edit Settings",
    "Save Settings": "Save Settings",
    "Reboot needed: Please reboot the device after changing the IP configuration.": "Reboot needed: Please reboot the device after changing the IP configuration.",
    "Afterwards wait a few minutes and then reload this web side.": "Afterwards wait a few minutes and then reload this web side.",
    "To modify the settings you need to login as administrator:": "To modify the settings you need to login as administrator:",
    "Login": "Login",
    "Rebooting System": "Rebooting System",
    "This will perform a reboot of this controller. The energy regulation and recording will not be available during this time. Are you sure?": "This will perform a reboot of this controller. The energy regulation and recording will not be available during this time. Are you sure?",
    "Powering Off System": "Powering Off System",
    "This will power-off this controller. The controller will be unusable until you disconnect and reconnect its power supply. Are you sure?": "This will power-off this controller. The controller will be unusable until you disconnect and reconnect its power supply. Are you sure?",
    "Select IP Mode": "Select IP Mode",
    "The entered operator passwords are not equal. Aborting change.": "The entered operator passwords are not equal. Aborting change.",
    "Change Hostname": "Change Hostname",
    "The hostname may only contain lowercase letters, digits and the hyphen ('-') character. Aborting change.": "The hostname may only contain lowercase letters, digits and the hyphen ('-') character. Aborting change.",
    "RFID": "RFID",
    "Perform Login": "Perform Login",
    "Forgot Password?": "Forgot Password?",
    "Sign-Up here...": "Sign-Up here...",
    "Hold NFC card to reader.": "Hold NFC card to reader.",
    "Scan NFC card": "Scan NFC card",
    "This charger card number is not allowed to login.": "This charger card number is not allowed to login.",
    "Back to Last View": "Back to Last View",
    "Click here to see the list of energy meters": "Click here to see the list of energy meters",
    "Energy meters": "Energy meters",
    "Back to report list": "Back to report list",
    "Report": "Report",
    "Error while loading data": "Error while loading data",
    "Error while loading report": "Error while loading report",
    "Loading Data...": "Loading Data...",
    "Report Items": "Report Items",
    "Create New": "Create New",
    "Report Options": "Report Options",
    "Limit period from": "Limit period from",
    "Limit period until": "Limit period until",
    "Back to Rfid List": "Back to Rfid List",
    "Edit Charging Card": "Edit Charging Card",
    "User Settings": "User Settings",
    "Charger Control Settings": "Charger Control Settings",
    "Varibale Cost Tariff": "Varibale Cost Tariff",
    "show tariff in charger power graph": "show tariff in charger power graph",
    "Vehicle Identifier": "Vehicle Identifier",
    "Vehicle Battery": "Vehicle Battery",
    "This section sets the default settings for the user defined charger power control, which are automatically applied when a new charging session is started.": "This section sets the default settings for the user defined charger power control, which are automatically applied when a new charging session is started.",
    "The settings can be adapted then for each running charging.session.": "The settings can be adapted then for each running charging.session.",
    "Connect to Site": "Connect to Site",
    "Currently, you are not connected to a site.": "Currently, you are not connected to a site.",
    "You need to connect to the site to see live data or to make any changes.": "You need to connect to the site to see live data or to make any changes.",
    "Please select the site you want to monitor.": "Please select the site you want to monitor.",
    "Connect": "Connect",
    "Favorites": "Favorites",
    "Loading the list of available sites. Please wait.": "Loading the list of available sites. Please wait.",
    "Currently, there is no site available, which you can connect to.": "Currently, there is no site available, which you can connect to.",
    "Please contact the system administrator to assign a site to your user.": "Please contact the system administrator to assign a site to your user.",
    "You are connected to this site:": "You are connected to this site:",
    "Serial": "Serial",
    "Trend / Live Data": "Trend / Live Data",
    "Disconnect": "Disconnect",
    "Connect Offline": "Connect Offline",
    "Site Settings": "Site Settings",
    "Select site": "Select site",
    "Favorite": "Favorite",
    "Site Administration": "Site Administration",
    "Back to Site Selection": "Back to Site Selection",
    "Execution Pending": "Execution Pending",
    "Open SSH Tunnel": "Open SSH Tunnel",
    "Import Trend Data": "Import Trend Data",
    "This will open an SSH tunnel to the embyt server, which stays active for one hour. Connect via ssh -p 43022 embyt@enl-tun.embyt.com. Are you sure?": "This will open an SSH tunnel to the embyt server, which stays active for one hour. Connect via ssh -p 43022 embyt@enl-tun.embyt.com. Are you sure?",
    "This will reboot the enline controller, which will stop energy regulation and may last several minutes. Are you sure?": "This will reboot the enline controller, which will stop energy regulation and may last several minutes. Are you sure?",
    "Back to Timeseries": "Back to Timeseries",
    "Current User": "Current User",
    "The following user is currently logged into this website.": "The following user is currently logged into this website.",
    "Charging Card": "Charging Card",
    "Logout": "Logout",
    "Settings": "Settings",
    "You have the access right to administrate other users.": "You have the access right to administrate other users.",
    "Please select the user to modify in the drop-down box below and press modify afterwards.": "Please select the user to modify in the drop-down box below and press modify afterwards.",
    "Modify": "Modify",
    "To add a new user press the create button below.": "To add a new user press the create button below."
  },
  "de": {
    "Electrical": "Strom",
    "Water": "Wasser",
    "Gas": "Gas",
    "thisperiod_": "keine",
    "thisperiod_day": "heute",
    "thisperiod_week": "diese Woche",
    "thisperiod_month": "dieser Monat",
    "thisperiod_year": "dieses Jahr",
    "thisperiod_custom": "benutzerdefiniert",
    "thisperiod_all": "Gesamt",
    "TimePeriod_": "keine",
    "TimePeriod_day": "Tag",
    "TimePeriod_week": "Woche",
    "TimePeriod_month": "Monat",
    "TimePeriod_year": "Jahr",
    "TimePeriod_all": "Gesamt",
    "TimePeriod_custom": "benutzerdefiniert",
    "Period_none": "keine",
    "Period_hour": "Stunde",
    "Period_day": "Tag",
    "Period_month": "Monat",
    "Period_year": "Jahr",
    "FilterPeriod_day": "heute",
    "FilterPeriod_month": "aktueller Monat",
    "FilterPeriod_year": "aktuelles Jahr",
    "FilterPeriod_last_day": "gestern",
    "FilterPeriod_last_month": "letztes Monat",
    "FilterPeriod_last_year": "letztes Jahr",
    "AutoexportPeriod_none": "deaktiviert",
    "AutoexportPeriod_day": "täglich",
    "AutoexportPeriod_month": "monatlich",
    "AutoexportPeriod_year": "jährlich",
    "ReportFormat_xlsx": "Microsoft Excel (.xlsx)",
    "ReportFormat_xls": "Microsoft Excel (.xls)",
    "ReportFormat_ods": "OpenDocument Spreadsheet (.ods)",
    "ReportFormat_csv": "Comma Separated Values (.csv)",
    "ReportFormat_txt": "Tab Separated Values (.txt)",
    "ReportFormat_html": "HTML Tables (.html)",
    "ReportFormat_rtf": "Rich Text Format (.ŕtf)",
    "ReportCSVDelimiter_,": ", [Komma]",
    "ReportCSVDelimiter_;": "; [Strichpunkt]",
    "ReportCSVDelimiter_\t": "(\\t) [Tabulator]",
    "ReportCSVDelimiter_|": "| [Pipe]",
    "userrole_": "-",
    "userrole_viewer": "Benutzer",
    "userrole_admin": "Administrator",
    "userrole_root": "root",
    "DeviceType_embyt-strato": "enline CC",
    "DeviceType_LIOB-586": "SMART-586",
    "DeviceType_LINX-153": "EMS-153",
    "DeviceType_LINX-120": "EMS-120",
    "DeviceType_virtual": "Virtual",
    "DeviceType_embyt-pc": "PC",
    "DeviceType_cloud": "Cloud Controller",
    "TrendMember_costs": "Kosten",
    "TrendMember_energy": "Energy",
    "TrendMember_power": "Leistung",
    "TrendingColumn_tariff_energy": "Energie pro Tarif",
    "TrendingColumn_energy": "Energie",
    "TrendingColumn_max_energy": "Maximale Periodenenergie",
    "TrendingColumn_target_value": "Sollwert",
    "TrendingColumn_max_power": "Maximale Momentanleistung",
    "TrendingColumn_tariff_cost": "Kosten pro Tarif",
    "TrendingColumn_cost": "Energiekosten",
    "TrendingColumn_peak_cost": "Spitzenlastkosten",
    "TrendingColumn_energymeter": "Zählerstand",
    "TrendingColumn_energy_max": "Energie Maximalwert",
    "TrendingColumn_energy_avg": "Energie Mittelwert",
    "TrendingColumn_energy_min": "Energie Minimalwert",
    "ChargerColumn_energy": "Energie",
    "ChargerColumn_duration": "Dauer",
    "ChargerColumn_rfid": "RFID Karte",
    "ChargerColumn_user": "RFID Benutzer",
    "ChargerColumn_vehicle": "Fahrzeug",
    "ChargerColumn_charger": "Ladestation",
    "ChargerColumn_connector": "Anschluss",
    "ChargerColumn_meter_value": "Startzählerstand",
    "ChargerColumn_stop_meter_value": "Endzählerstand",
    "ChargerColumn_costs": "Kosten",
    "ChargerColumn_tariff": "Tarif",
    "ChargerColumn_stop_reason": "Stoppgrund",
    "ChargerColumn_category": "Kategorie",
    "ChargerColumn_additional_data": "Zusatzinfo",
    "chargingstate_0": "nicht bereit",
    "chargingstate_1": "bereit",
    "chargingstate_2": "lädt",
    "chargingstate_3": "gestoppt",
    "chargingstate_4": "Fehler",
    "chargingstate_5": "gestoppt durch Auto",
    "plugstate_0": "kein Kabel",
    "plugstate_1": "Kabel in Ladestation",
    "plugstate_2": "Kabel in Auto und Ladestation",
    "AlarmSource_NVAlarm_Targetvalue": "Sollwert überschritten",
    "AlarmSource_NVAlarm_Restart": "System Neustart",
    "AlarmSource_NVAlarm_MissingSync": "Fehlender Sync-Puls",
    "AlarmSource_NVAlarm_EnergyMeter": "Energiezählerfehler",
    "AlarmSource_NVAlarm_Modul": "IO-Modul Fehler",
    "AlarmSource_NVAlarm_ManualActive": "Handschaltung aktiv",
    "AlarmSource_NVAlarm_LINX": "Controller Fehler",
    "AlarmSource_Cloud_Offline": "Anlage Offline",
    "AlarmSource_Cloud_TrendMonitor": "Überschreitung Verbrauchsüberwachung",
    "AlarmSource_Cloud_ChargerOffline": "Ladestation Offline",
    "AlarmSource_Cloud_ChargerFaulted": "Ladeanschluss fehlerhaft",
    "AlarmSource_Cloud_ChargingInterrupted": "Ladevorgang unterbrochen",
    "ChargerModel_0": "Anderer",
    "ChargerModel_1": "Bender",
    "ChargerModel_2": "go-e",
    "ChargerModel_3": "PCE",
    "ChargerModel_4": "Keba",
    "ChargerModel_5": "Etrel",
    "ChargerModel_6": "Circontrol",
    "ChargerModel_7": "OCPP",
    "ChargerModel_8": "Salia",
    "ChargerStatus_": "Offline",
    "ChargerStatus_Available": "Verfügbar",
    "ChargerStatus_Preparing": "Vorbereitend",
    "ChargerStatus_Charging": "Ladend",
    "ChargerStatus_SuspendedEV": "Pause Fahrzeug",
    "ChargerStatus_SuspendedEVSE": "Pause Station",
    "ChargerStatus_Finishing": "Fertig",
    "ChargerStatus_Reserved": "Reserviert",
    "ChargerStatus_Unavailable": "Nicht verfügbar",
    "ChargerStatus_Faulted": "Fehlerhaft",
    "StopReason_": "Unbekannt",
    "StopReason_DeAuthorized": "Nicht berechtigt",
    "StopReason_EmergencyStop": "Not-Stop",
    "StopReason_EVDisconnected": "Kabel getrennt",
    "StopReason_HardReset": "Hard Reset",
    "StopReason_Local": "Lokal vom Benutzer gestoppt",
    "StopReason_Other": "Sonstiges",
    "StopReason_PowerLoss": "Stromausfall",
    "StopReason_Reboot": "Neustart der Ladestation",
    "StopReason_Remote": "Stopp vom Zentralsystem oder Berechtigung abgelaufen",
    "StopReason_SoftReset": "Soft-Reset",
    "StopReason_UnlockCommand": "Entriegeln durch Zentralsystem",
    "StopReason_Unauthenticated": "Nicht authentifiziert",
    "StopReason_NotEnded": "Ende des Ladevorgangs nicht erkannt",
    "StopReason_SessionEnd": "-",
    "OcppCmdStatus_": "Unbekannt",
    "OcppCmdStatus_none": "Kein Befehl anstehend.",
    "OcppCmdStatus_new": "Löse Befehl aus.",
    "OcppCmdStatus_issued": "Sende Befehl.",
    "OcppCmdStatus_sent": "Führe Befehl aus.",
    "OcppCmdStatus_confirmed": "Befehl ausgeführt.",
    "ChargingMode_early": "so früh wie möglich",
    "ChargingMode_late": "so spät wie möglich",
    "ChargingMode_uniform": "gleichmäßig langsam",
    "ChargingMode_costOptimized": "ökologisch",
    "ChargingMode_pvOptimized": "PV-optimiert",
    "DashboardPanel_": "<automatisch>",
    "DashboardPanel_empty": "<leer>",
    "DashboardPanel_Alarms": "Alarme",
    "DashboardPanel_EMobility": "E-Mobilität",
    "DashboardPanel_Energy": "Verbrauchsdaten",
    "DashboardPanel_Inputs": "Eingänge",
    "DashboardPanel_Monitor": "Monitor",
    "DashboardPanel_Outputs": "Ausgänge",
    "DashboardPanel_Power": "Leistung",
    "DashboardPanel_Reports": "Berichte",
    "DashboardPanel_SiteInfos": "Anlageninformationen",
    "DashboardPanel_TrendMonitor": "Verbrauchsüberwachung",
    "Rfid_LimitEnergyPeriod_---": "---",
    "Rfid_LimitEnergyPeriod_DAY": "Tag",
    "Rfid_LimitEnergyPeriod_MONTH": "Monat",
    "Rfid_LimitEnergyPeriod_YEAR": "Jahr",
    "Create": "Anlegen",
    "SignUp": "Erstanmeldung",
    "User exists already!": "Benutzer existiert bereits!",
    "Incorrect username or password.": "Benutzername oder Passwort ist falsch.",
    "oldPassword and newPassword are required to changePassword": "Altes und Neues Passwort wird benötigt um Ihr Passwort zu ändern.",
    "Password did not conform with policy: Password not long enough": "Neues Passwort zu kurz.",
    "Attempt limit exceeded, please try after some time.": "Maximale Anzahl an Versuchen überschritten, versuchen Sie es etwas später nochmal.",
    "ImporterStatus_": "Unbekannt",
    "ImporterStatus_initial": "Gestartet",
    "ImporterStatus_received": "In Bearbeitung",
    "ImporterStatus_processed": "Import abgeschlossen",
    "ImporterStatus_error": "Fehler",
    "ImporterStatus_upload_failed": "Upload fehlgeschlagen",
    "ImporterStatus_import_failed": "Import fehlgeschlagen",
    "ImporterFileType_TrendData": "Verbrauchsdaten",
    "ImporterFileType_EDA": "EDA",
    "ImporterFileType_EVU": "EVU",
    "ImporterFileTypes_EVU": "Lastgangdaten",
    "ImporterFileTypes_EDA": "EDA Daten",
    "DeletionStrategy_small": "Löschmodell klein",
    "DeletionStrategy_large": "Löschmodell groß",
    "DeletionStrategy_unlimited": "Löschmodell unbegrenzt",
    "Acknowledge": "Bestätigen",
    "active": "aktiv",
    "pending": "Bestätigung offen",
    "active, acknowledged": "aktiv, bestätigt",
    "acknowledged": "bestätigt",
    "acknowledge this alarm and older alarms of same type": "bestätige diesen und alle älteren Alarme des gleichen Typs",
    "Enabled": "Aktiviert",
    "yes": "ja",
    "no": "nein",
    "Alarm Settings": "Alarmeinstellungen",
    "Activated Alarms": "Aktivierte Alarme",
    "enabled": "aktiviert",
    "disabled": "deaktiviert",
    "Timeout": "Zeitüberschreitung",
    "hour(s)": "Stunde(n)",
    "Email Notifications": "Email Benachrichtigungen",
    "Email Address": "Email-Adresse",
    "SoC": "SoC",
    "Changing password...": "Ändere Passwort...",
    "Checking sign-up...": "Überprüfe Sign-Up",
    "Checking login...": "Überprüfe Anmeldung...",
    "Loading site list...": "Lade Anlagenliste...",
    "Error loading parameters.": "Fehler beim Laden der Parameter.",
    "Loading parameters...": "Lade Parameter...",
    "Loading site data...": "Lade Anlagedaten...",
    "All categories": "Alle Kategorien",
    "Without mapping": "Ohne Zuordnung",
    "Select category": "Auswahl Kategorie",
    "Charger Status": "Status Ladestation",
    "Offline": "Offline",
    "Connector Status": "Status Anschluss",
    "Energymeter": "Energiezähler",
    "Voltage": "Spannung",
    "Charging Power": "Ladeleistung",
    "Charging Current": "Ladestrom",
    "Energy Session": "Energie Ladung",
    "show all charging sessions": "alle Ladevorgänge anzeigen",
    "No chargers present.": "Keine Ladestationen vorhanden.",
    "Connector": "Anschluss",
    "Search for chargers...": "Suche nach Ladestationen...",
    "Search for charger name, vendor or serial number. To search for multiple fields, separate search texts by a space!": "Suche nach Ladestationsname, Hersteller oder Seriennummer. Um nach mehreren Feldern zu suchen müssen die Suchtexte durch ein Leerzeichen getrennt werden!",
    "Vendor": "Hersteller",
    "Model": "Modell",
    "Software": "Software",
    "Serial Number": "Seriennummer",
    "Last Data": "Letzte Daten",
    "Charging authentication": "Ladefreigabe",
    "Authorized": "Beschränkt",
    "Public": "Öffentlich",
    "Charger index": "Ladestation-Index",
    "Suspended": "Pausiert",
    "change settings": "Einstellungen ändern",
    "print": "drucken",
    "Charging Control": "Ladesteuerung",
    "Save": "Speichern",
    "Limit power": "Leistungsbegrenzung",
    "Limit the power to": "Begrenze die Leistung auf",
    "Please notice that a minimum charging power exists that cannot be fallen below. The resulting charging power might be increased.": "Bitte beachten Sie, dass es eine Mindestladeleistung gibt, die nicht unterschritten werden kann. Die resultierende Ladeleistung kann erhöht sein.",
    "Limit energy": "Energiebegrenzung",
    "Limit the energy to": "Begrenze die Energie auf",
    "Already charged:": "Bereits geladen:",
    "Charging Strategy": "Ladestrategie",
    "Charge immediately and stop after requested energy is reached.": "Lädt sofort und stoppt, wenn die angeforderte Energie erreicht ist.",
    "Charge as late as possible to match requested energy and departure time.": "Lädt so spät wie möglich, um die angeforderte Energie und Abfahrtszeit zu erreichen.",
    "Charge with least possible power to match requested energy and departure time. Please notice that a minimum charging power exists that cannot be fallen below.": "Lädt mit geringstmöglicher Leistung, um die angeforderte Energie und Abfahrtszeit zu erreichen. Bitte beachten Sie, dass es eine Mindestladeleistung gibt, die nicht unterschritten werden kann.",
    "Charge in those periods where the energy prices (EPEX Spot) are lowest. This is cost optimal if you have a variable energy price and environmental friendly as it uses off-peak periods.": "Lädt zu den Zeiten, in denen die Energiepreise (EPEX Spot) am niedrigsten sind. Das ist kostenoptimal, wenn Sie einen variablen Energiepreis haben und umweltfreundlich, da es Schwachlastzeiten nutzt.",
    "Charge in those periods where Photo Voltaic power is maximum during the period until the departure time.": "Lädt zu den Zeiten, in denen die PV-Leistung im Zeitraum bis zur Abfahrtszeit maximal ist.",
    "Automatically activate this charging strategy for new charging sessions": "Aktiviere diese Ladestrategie automatisch für zukünftige neue Ladevorgänge",
    "Please notice that if you limit both, the power and the energy, the resulting lower charging limit will be used.": "Bitte beachten Sie, dass, wenn Sie sowohl die Leistung als auch die Energie begrenzen, die resultierende geringere Ladegrenze verwendet wird.",
    "Departure time": "Abreisezeit",
    "Charging Progress": "Ladeverlauf",
    "charging power": "Ladeleistung",
    "tariff": "Tarif",
    "MMM d": "d MMM",
    "h a": "H",
    "h:mm a": "H:mm",
    "Conditions": "Bedingungen",
    "Name": "Name",
    "Value": "Wert",
    "No conditions present.": "Keine Bedingungen vorhanden",
    "Search for condition...": "Suche nach Bedingungen...",
    "OK": "OK",
    "Cancel": "Abbrechen",
    "Unsaved Changes": "Ungespeicherte Änderungen",
    "There are unsaved changes! On OK you confirm reverting the changes. Press Cancel if you want to save your changes.": "Sie haben nicht gespeicherte Änderungen! Um die Änderungen zu verwerfen, klicken Sie OK. Klicken Sie Abbrechen um die Änderungen speichern zu können.",
    "Select control circuit": "Auswahl Regelkreis",
    "Energy [kWh]": "Energie [kWh]",
    "No option available": "Keine Option verfügbar",
    "Select All": "Alle auswählen",
    "Chargers": "Ladestationen",
    "Charging Cards": "Ladekarten",
    "Select E-Mobility info": "E-Mobility Info auswählen",
    "Failed to load data.": "Fehler beim Laden der Daten.",
    "No data available. Try reset zooming.": "Keine Daten verfügbar. Versuchen Sie, den Zoom zurückzusetzen.",
    "Please select tariff circuit.": "Bitte wählen Sie einen Tarifkreis.",
    "No data available.": "Keine Daten verfügbar.",
    "reset zoom": "Zoom zurücksetzen",
    "Energy Meters": "Energiezähler",
    "Module": "Modul",
    "Energy Source": "Energieträger",
    "Number": "Nummer",
    "No energy meters present.": "Keine Energiezähler vorhanden",
    "Back to Power View": "Zurück zur Leistungsansicht",
    "Search for energy meter...": "Energieszähler filtern...",
    "All energy sources": "Alle Energieträger",
    "Select energy source": "Energieträger auswählen",
    "Only .xlsx files are supported for import!": "Es werden nur .xlsx Files für den Import unterstützt!",
    "Only 1 file at once allowed on import!": "Nur 1 File pro Import erlaubt!",
    "Import data from file": "Daten aus Datei importieren",
    "Drop file here or": "Datei hier ablegen oder",
    "click to upload": "klicken Sie hier um ein File zu wählen",
    "All hierarchies": "Alle Hierarchien",
    "Root": "Wurzel",
    "Select hierarchy": "Hierarchie auswählen",
    "Hierarchy Up": "Hierarchieebene höher",
    "File upload failed. Please try again.": "Upload fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "File import failed. Please try again.": "Import fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "Refresh": "Aktualisieren",
    "Status": "Status",
    "Uploaded on": "Upload vom",
    "Info": "Info",
    "Duration": "Dauer",
    "Select type of import": "Wählen Sie die Art des Imports",
    "Select tariff circuit (import destination)": "Tarifkreis wählen (Importziel)",
    "File upload started. Please wait.": "Dateiupload gestartet. Bitte warten.",
    "Import load curve data": "Import Lastgangdaten",
    "Imported data will replace (delete!) data with the same timestamp!": "Importierte Daten ersetzen (löschen!) Daten mit dem gleichen Zeitstempel!",
    "The file must be in the following format:": "Die Datei muss im folgenden Format vorliegen:",
    "Cloumn header for the timestamps: 'Zeitpunkt'": "Spaltenüberschrift der Zeitstempel: 'Zeitpunkt'",
    "The next column after the timestamp column must contain the power values in kW": "Die nächste Spalte nach der Zeitstempelspalte muss die Leistungswerte in kW enthalten",
    "The timestamps are in Central European (Summer) Time (CET and CEST)": "Die Zeitstempel entsprechen mitteleuropäischer (Sommer-)Zeit (MEZ oder MESZ)",
    "This corresponds to the enline trend report 'EVU Format' with 'maximum period energy', the grouping 'date, then tariff circuit', aggregation 'none', filtered by exactly one tariff circuit, and output format 'Microsoft Excel (.xlsx)'.": "Das entspricht dem enline Bericht 'Format EVU' mit 'Maximale Periodenenergie', der Gruppierung 'Datum, dann Tarifkreis', Aggregation 'keine', gefiltert nach genau einem Tarifkreis und Ausgabeformat Excel (.xlsx).",
    "Alternatively the file can be formatted in some typical EVU format; ": "Alternativ kann die Datei in einem typischen EVU-Format vorliegen; ",
    "the following link provides an example of such a file: ": "Der folgende Link bietet ein Beispiel für eine solche Datei: ",
    "Import EDA data": "Import EDA Daten",
    "The file must be in the format of 'EDA Energiedatenreport'.": "Die Datei muss im Format des 'EDA Energiedatenreport' vorliegen.",
    "The importer will search in the current site for a tariff circuit with exactly one associated energy meter which has the same number as one of the MeteringpointIDs. If found, data is imported to that tariff circuit. This procedure is repeated for each MeteringpointID found in the EDA file.": "Der Importer sucht in der aktuellen Anlage nach einem Tarifkreis mit genau einem zugeordneten Energiezähler, der die gleiche Nummer wie eine der Zählpunktnummern hat. Wird dieser gefunden, werden die Daten in diesen Tarifkreis importiert. Dieser Vorgang wird für jede in der EDA-Datei gefundene Zählpunktnummer wiederholt.",
    "Select Tariff Circuit": "Tarifkreis auswählen",
    "Select Import Type": "Auswahl der Import-Art",
    "No Info": "Keine Information",
    "tariff circuit(s) imported": "Taifkreis",
    "tariff circuit not found": "Tarifkreis nicht gefunden",
    "Upload failed": "Upload fehlgeschlagen",
    "Import failed": "Import fehlgeschlagen",
    "change value": "Wert ändern",
    "Inputs": "Eingänge",
    "No inputs present.": "Keine Eingänge vorhanden.",
    "Search for inputs...": "Eingänge filtern...",
    "On": "Ein",
    "Off": "Aus",
    "Timestamp": "Zeitstempel",
    "New State": "Neuer Zustand",
    "Activities": "Aktivitäten",
    "Off Time": "Inaktiv Zeit",
    "On Time": "Aktiv Zeit",
    "The number of input/output trend data items is very high.": "Die Anzahl der Einträge in der Ein- und Ausgangsdatenaufzeichnung ist sehr groß.",
    "Therefore the data table might be truncated and not complete.": "Deshalb könnte die Datentabelle abgeschnitten und nicht vollständig sein.",
    "Mixed": "Gemischt",
    "Data loading...": "Lade Daten...",
    "Pending sign-up confirmation.": "Account-Bestätigung noch ausständing.",
    "User already exists - try to login.": "Benutzer existiert bereits - versuchen Sie sich anzumelden.",
    "This email address is not allowed to sign-up.": "Diese email Adresse ist im System nicht freigegeben.",
    "Please contact your administrator.": "Bitte kontaktieren Sie Ihren Administrator.",
    "Code has expired - request a new one.": "Der Bestätigungscode ist abgelaufen - fordern Sie einen neuen an.",
    "Code not valid - request a new one.": "Ungültiger Bestätigungscode - fordern Sie einen neuen an.",
    "Password does not meet minimum requirements on length and complexity.": "Das Passwort erfüllt nicht die Mindestanforderungen an Länge und Komplexität.",
    "You are already confirmed - try to login.": "Ihr Account wurde bereits bestätigt - versuchen Sie sich anzumelden.",
    "Confirmation failed - please try again.": "Bestätigung fehlgeschlagen - bitte versuchen Sie es erneut.",
    "Email missing - please enter your email.": "Keine E-Mail-Adresse angegeben - bitte geben Sie Ihre Email-Adresse an.",
    "Password missing - please enter your password.": "Kein Passwort angegeben - bitte geben Sie Ihr Passwort an.",
    "Confirmation code missing - please enter the code.": "Kein Bestätigungscode angegeben - bitte geben Sie den Bestätigungscode an.",
    "Unknown error: ": "Unbekannter Fehler: ",
    "Login failed.": "Anmeldung fehlgeschlagen.",
    "Changing password failed.": "Passwortänderung fehlgeschlagen.",
    "Failed": "Fehler",
    "Unknown": "Unbekannt",
    "Input(s)": "Eingang(e)",
    "Output(s)": "Ausgang(e)",
    "Energy Meter(s)": "Energyzähler",
    "Modules": "Module",
    "Type": "Typ",
    "Address": "Adresse",
    "Usage": "Verwendung",
    "Comment": "Kommentar",
    "No modules present.": "Keine Module vorhanden.",
    "Search for module...": "Suche nach Modulen...",
    "Target": "Ziel",
    "Trend": "Trend",
    "Cummulated Power": "Summierte Leistung",
    "Trended Power": "Tendenz-Leistung",
    "Target Value": "Zielwert",
    "Period Runtime": "Periodenlaufzeit",
    "Current Power": "Momentanleistung",
    "Control Level": "Regelungsstufe",
    "Chargepoint-ID": "Chargepoint-ID",
    "Connectors": "Anschlüsse",
    "Authentication": "Freigabe",
    "charging is only allowed to valid RFID cards": "nur gültige RFID Karten dürfen laden",
    "charging is only allowed to everyone": "Ladevorgänge sind für jeden erlaubt",
    "Stop Charging": "Ladevorgang stoppen",
    "Unlock Connector": "Stecker entriegeln",
    "Authorize Charging": "Ladevorgang freigeben",
    "Reboot Charger": "Ladestation neu starten",
    "Timeout Error": "Zeitüberschreitung",
    "Stopping charging session": "Ladevorgang stoppen",
    "This will stop the ongoing charging session. Are you sure?": "Dadurch wird der laufende Ladevorgang beendet. Sind Sie sicher?",
    "Unlocking connector": "Stecker entriegeln",
    "This will stop the ongoing charging session and unlock the charging connector. Are you sure?": "Dadurch wird der laufende Ladevorgang beendet und der Ladeanschluss entsperrt. Sind Sie sicher?",
    "Resetting charging session": "Ladestation rücksetzen",
    "This will trigger a reset of the charging session. Are you sure?": "Dies löst ein Reset der Ladestation aus. Sind Sie sicher?",
    "analog": "Analog",
    "control value": "Vorgabewert",
    "override": "Überschreiben",
    "Outputs": "Ausgänge",
    "No outputs present.": "Keine Ausgänge vorhanden.",
    "Search for outputs...": "Ausgänge filtern...",
    "Select period": "Zeitraum auswählen",
    "Select Date": "Datum wählen",
    "Start Date": "Start",
    "End Date": "End",
    "switch to hierarchy view": "Wechsle zur Hierarchieansicht",
    "switch to sankey view": "Wechsle zur Sankeyansicht",
    "switch to pie-chart view": "Wechsle zur Graphansicht",
    "switch to list view": "Wechsle zur Tabellenansicht",
    "highlight tariffs circuits...": "Tarifkreise hervorheben...",
    "internal error...": "Interner Fehler...",
    "Refused Charging Cards": "Abgelehnte Ladekarten",
    "Card Number": "Kartennummer",
    "Charger": "Ladestation",
    "First Attempt": "Erster Versuch",
    "Last Attempt": "Letzer Versuch",
    "Counter": "Zähler",
    "No refused charging cards detected within the last 7 days.": "Es gab keine abgelehnten Ladekarten innerhalb der letzten 7 Tage.",
    "add this as new charging card": "dies als neue Ladekarte hinzufügen",
    "View Report Online": "Zeige Bericht",
    "Update Report File": "Aktualisiere Bericht",
    "Create Report File": "Erzeuge Bericht",
    "Download": "Download",
    "Report generation timed out. Try reducing report content.": "Berichterstellung Time-Out. Bitte reduzieren Sie den Berichtsumfang.",
    "generating report": "Berichterstellung in Arbeit",
    "Card number": "Kartennummer",
    "all chargers": "alle Ladestationen",
    "Valid from": "Gültig ab",
    "Valid until": "Gültig bis",
    "Energy/Cost limit": "Energie/Kostenbegrenzung",
    "Last Usage": "Letzte Verwendung",
    "Never": "Nie",
    "used energy and costs exclude ongoing charging sessions": "verbrauchte Energie und Kosten, ohne laufende Ladevorgänge",
    "No charging card with active charging session found.": "Keine Ladekarte mit aktivem Ladevorgang gefunden.",
    "No charging card found.": "Keine Ladkarte gefunden.",
    "Charging since": "Laden seit",
    "Search for cards...": "Nach Karten suchen...",
    "Search for cards-numbers, names or categories. To search for multiple fields, separate search texts by a space!": "Suche nach Kartennummern, Namen oder Kategorien. Um nach mehreren Feldern zu suchen müssen die Suchtexte durch ein Leerzeichen getrennt werden!",
    "Too many active charging cards (>150).": "Zu viele aktive Ladekarten (>150).",
    "Displaying of additional details and editing of charging cards is not possible.": "Die Anzeige weitere Details und das Bearbeiten von Ladekarten ist nicht möglich.",
    "Card data not fully loaded yet.": "Kartendaten noch nicht vollständig geladen.",
    "If this persists, please reduce the number of active charging cards.": "Wenn dies verbleibt, reduzieren Sie bitte die Anzahl der aktiven Ladekarten.",
    "No charging cards added yet.": "Bisher wurden keine Ladekarten hinzugefügt.",
    "Show Inactive": "Zeige deaktivierte",
    "New Charging Card": "Neue Ladekarte",
    "Delete Inactive Cards": "Lösche inaktive Karten",
    "Category": "Kategorie",
    "Validity": "Gültigkeit",
    "Energy Limit": "Energielimit",
    "edit charging card": "bearbeite Ladekarte",
    "link charging card": "verbinde Ladekarte",
    "delete charging card": "lösche Ladekarte",
    "the energy and cost limits exclude ongoing charging sessions": "die Energie- und Kostenbegrenzungen, ohne laufende Ladevorgänge",
    "Deleting charging card": "Ladekarte löschen",
    "This will delete this charging card. The charging data itself will still be available. Are you sure?": "Dies löscht diese Ladekarten. Die Ladedaten selbst bleiben verfügbar. Sind Sie sicher?",
    "This will delete all inactive charging cards of the list. Are you sure?": "Dies löscht alle inaktiven Ladekarten. Sind Sie sicher?",
    "The number of active charging cards exceeds the limit. Please delete some cards to be able to create new cards.": "Die Anzahl der aktiven Ladekarten überschreitet das Limit. Bitte löschen Sie bestehende Karten, um neue Karten erstellen zu können.",
    "Available": "Verfügbar",
    "Charging": "Ladevorgänge",
    "Expired": "Abgelaufen",
    "Data modified.": "Daten geändert.",
    "Saving data...": "Daten werden gespeichert...",
    "Sucessfully saved data.": "Daten erfolgreich gespeichert.",
    "Saving data failed": "Speichern der Daten fehlgeschlagen",
    "Saving data failed.": "Speichern der Daten fehlgeschlagen.",
    "Database Policy": "Datenbankrichtlinie",
    "End Customer": "Endkunde",
    "Order Number": "Auftragsnummer",
    "Service Type": "Anlagentyp",
    "Comments": "Anmerkungen",
    "Select deletion strategy": "Löschstrategie auswählen",
    "No site information available!": "Keine Anlageninformation vorhanden!",
    "Current Site": "Aktuelle Anlage",
    "None": "Keine",
    "Tariff": "Tarif",
    "Priority": "Priorität",
    "Site tariffs are used.": "Anlagentarife werden verwendet.",
    "Add Tariff": "Tarif hinzufügen",
    "Select Tariff": "Tarif auswählen",
    "No more tariffs available.": "Keine weiteren Tarife verfügbar.",
    "Select tariff": "Wähle Tarif",
    "remove tariff from this charging card": "entferne Tarif von dieser Ladekarte",
    "save tariff to this charging card": "füge Tarif dieser Ladekarte hinzu",
    "related to: ": "bezogen auf: ",
    "Parent": "Bereich",
    "No tariff circuits present.": "Keine Tarifkreise vorhanden.",
    "Select tariff circuit": "Auswahl Tarifkreis",
    "No tariff available": "Kein Tarif verfügbar",
    "All tariff circuits": "Alle Tarifkreise",
    "all": "alle",
    "items selected": "Einträge ausgewählt",
    "New Tariff": "Neuer Tarif",
    "New Site Tariff": "Neuer Anlagentarif",
    "Add Global Tariff": "Globalen Tarif hinzufügen",
    "Cost Tariffs": "Kostentarife",
    "Cost per Energy": "Kosten pro Energie",
    "Cost per Period": "Kosten pro Zeit",
    "Time Restriction": "Tageszeit",
    "No tariff added yet.": "Keine Tarife vorhanden.",
    "edit tariff": "bearbeite Tarif",
    "delete tariff": "lösche Tarif",
    "Delete cost tariff": "Kostentarif löschen",
    "This will delete this tariff. All associated costs will be lost. Are you sure?": "Die löscht diesen Tarif. Alle damit verbundenen Kosten gehen verloren. Wollen Sie fortfahren?",
    "Tariffcircuit": "Tarifkreis",
    "Period": "Zeitraum",
    "Energy": "Energie",
    "Costs Energy": "Energiekosten",
    "Power": "Leistung",
    "Sum / Max": "Summe / Max.",
    "switch to graph view": "wechsle zu Graphen",
    "Select data": "Daten auswählen",
    "Current data": "Aktuelle Daten",
    "Limit value": "Grenzwert",
    "Alarm limit": "Alarmschwelle",
    "Overshoot": "Überschreitung",
    "Select trend monitor": "Wähle Verbrauchsüberwachung",
    "Complete user data": "Vervollständigen der Benutzerdaten",
    "Modify current user": "Aktuellen Benutzer modifzieren",
    "Full name": "Voller Name",
    "Email": "E-Mail",
    "User name needed!": "Benutzername erforderlich!",
    "Old password": "Altes Passwort",
    "Password needed": "Passwort erforderlich",
    "New password": "Neues Passwort",
    "Passwords are different": "Passwörter sind unterschiedlich",
    "Verify new password": "Wiederholung neues Passwort",
    "Finish User Setup": "Benutzereinstellungen fertig stellen",
    "Change Password": "Passwort ändern",
    "Changing User": "Ändere Benutzer",
    "The two fields for the new password do not match.": "Die beiden Felder für das neue Passwort stimmen nicht überein.",
    "Please enter the same password twice.": "Bitte geben Sie das gleiche Passwort zweimal ein.",
    "Reset Password": "Passwort zurücksetzen",
    "We've send an email with an verification code to your email address.": "Wir haben Ihnen eine Email mit einem Bestätigungscode gesendet.",
    "Please enter that code in the inut box and choose and verify your new password.": "Bitte geben Sie diesen Code in das Eingabefeld zusammen mit Ihrem neuen Passwort ein.",
    "You can request a verification code to be sent to your email address of your account.": "Sie können einen Bestätigungscode anfordern, der an Ihre Email-Adresse gesendet wird.",
    "Afterwards you can enter the received verification code here together with a new password.": "Danach können Sie den erhaltenen Bestätigungscode zusammen mit einem neuen Passwort eingeben.",
    "Check your Email Address": "Überprüfen Sie Ihre E-Mail Adresse",
    "Verification Code": "Bestätigungscode",
    "Verify password": "Verifiziere Passwort",
    "Request Verification Code": "Bestätigungscode anfordern",
    "Request New Code": "Neuen Code anfordern",
    "Resend Code...": "Code erneut zusenden...",
    "Requesting verification code failed.": "Anfordern des Bestätigungscodes fehlgeschlagen.",
    "Please enter the code you received via email": "Bitte geben sie den Bestätigungscode, welchen Sie in der E-Mail an",
    "together with your password...": "erhalten haben, zusammen mit Ihrem Passwort ein...",
    "below...": "erhalten haben, unten ein...",
    "Not your email?": "Nicht Ihre E-Mail?",
    "New Password": "Neues Passwort",
    "Check your Password": "Überprüfen Sie Ihr Passwort",
    "Verify new Password": "Passwortwiederholung",
    "Confirmation Code": "Bestätigungscode",
    "Password": "Passwort",
    "Confirm": "Bestätigung",
    "Dashboard": "Übersicht",
    "Monitor": "Monitor",
    "nav_Trend Data": "Verbrauch",
    "Trend Monitor": "Verbrauchsüberwachung",
    "Reports": "Berichte",
    "Public Display": "Public Display",
    "Current Status": "Aktueller Status",
    "Input/Outputs": "Ein/Ausgänge",
    "IO Graph": "IO-Graph",
    "E-Mobility": "E-Mobilität",
    "Energy Management Chargers": "Energiemanagement Ladestationen",
    "Configuration": "Konfiguration",
    "Charging Sessions": "Ladevorgänge",
    "Active Session": "Aktiver Ladevorgang",
    "Alarms": "Alarme",
    "Device": "Gerät",
    "by Energie-Plan + Management GmbH": "von Energie-Plan + Management GmbH",
    "offline": "offline",
    "view user": "zeige Benutzer",
    "view site": "zeige Anlage",
    "view controller settings": "zeige Controller Einstellungen",
    "Add Global or Removed Tariff": "Globalen oder entfernten Tarif hinzufügen",
    "No global tariffs available": "Keine globalen Tarife verfügbar",
    "add this global tariff to site": "diesen globalen Tarif zur Anlage hinzufügen",
    "Charger Settings": "Einstellungen Ladestation",
    "Delete Charger": "Ladestation löschen",
    "restricted charging": "beschränktes Laden",
    "charging always allowed": "Ladevorgang immer erlaubt",
    "Charger name": "Name der Ladestation",
    "Location": "Standort",
    "Latitude": "Breitengrad",
    "Longitude": "Längengrad",
    "Paste from Clipboard": "aus der Zwischenablage einfügen",
    "EVSE-ID": "EVSE-ID",
    "Plug": "Stecker",
    "Phases": "Phasen",
    "DC": "DC",
    "select charging authentication": "Ladefreigabe auswählen",
    "Delete charger": "Ladestation löschen",
    "This will delete this charger. All past charging sessions and charging data will be lost. Are you sure?": "Dadurch wird diese Ladestation gelöscht. Alle vergangenen Ladevorgänge und Ladedaten gehen verloren. Sind Sie sicher?",
    "Invalid Coordinates": "Ungültige Koordinaten",
    "Invalid coordinate values. Latitude must be between -90 and 90, longitude between -180 and 180.": "Ungültige Koordinatenwerte. Der Breitengrad muss zwischen -90 und 90, der Längengrad zwischen -180 und 180 liegen.",
    "Invalid coordinate format. Please use format: latitude, longitude (e.g., 48.203951, 16.402388)": "Ungültiges Koordinatenformat. Bitte verwenden Sie das Format: Breitengrad, Längengrad (z.B. 48.203951, 16.402388).",
    "Clipboard Error": "Fehler der Zwischenablage",
    "Failed to read from clipboard. Please ensure your browser supports clipboard access.": "Fehler beim Lesen der Zwischenablage. Bitte stellen Sie sicher, dass Ihr Browser den Zugriff auf die Zwischenablage unterstützt.",
    "Input Settings": "Eingang Einstellungen",
    "Switch": "Wechseln",
    "Changing the settings of this input item:": "Ändern der Einstllungen dieses Eingangs:",
    "Old value": "Alter Wert",
    "New value": "Neuer Wert",
    "Select value": "Wert auswählen",
    "Output Settings": "Ausgang Einstellungen",
    "Unknown/Offline": "Unbekannt/Offline",
    "Turn to Override Off": "Ändern zu Überschreiben Aus",
    "Turn to Override On": "Ändern zu Überschreiben Ein",
    "Switch Off": "Ausschalten",
    "Switch On": "Einschalten",
    "Changing the settings of this output item:": "Ändern der Einstellungen dieses Ausgangs:",
    "Current Value": "Aktueller Wert",
    "Override": "Überschreiben",
    "Command": "Befehl",
    "The new command will be executed immediately.": "Der neue Befehl wird sofort ausgeführt.",
    "Report Settings": "Analyseeinstellungen",
    "Trend Report": "Verbrauchsdatenbericht",
    "Charging Report": "Ladestationenbericht",
    "Input/Output Report": "Ein-/Ausgangbericht",
    "Site Report": "Anlagenbericht",
    "Title": "Titel",
    "Activated": "Aktiviert",
    "Delete Report": "Eintrag löschen",
    "IOs": "Ein/Ausgänge",
    "Sites": "Anlagen",
    "EVU Format": "EVU Format",
    "Data": "Daten",
    "Group By": "Gruppierung",
    "Aggregation": "Aggregation",
    "Reference": "Referenz",
    "no reference": "keine Referenz",
    "other tariff circuit": "anderer Tarifkreis",
    "previous time period": "vorhergehende Zeitperiode",
    "Filter": "Filter",
    "hide zero data values": "Verberge Nullwerte",
    "tariff circuits": "Tarifkreise",
    "start date": "Startdatum",
    "end date": "Enddatum",
    "period": "Periode",
    "Company": "Firma",
    "Output Format": "Ausgabeformat",
    "Delimiter": "Trennzeichen",
    "Hide Sum Row": "Verberge Summe",
    "Auto-Export": "Auto-Export",
    "recipient": "Empfänger",
    "new report": "neuer Bericht",
    "custom name of report": "Name des Berichts",
    "press CTRL (CMD on Mac) key to select mutliple items": "drücken Sie STRG (CMD am Mac) um mehrere Einträge auszuwählen",
    "email address for report receipt": "Email Adresse des Empfängers",
    "none": "keine",
    "date": "Datum",
    "tariff circuit": "Tarifkreis",
    "then": "dann",
    "charger": "Ladestation",
    "charging card": "Ladekarten",
    "Charging Card Links": "Ladekarten - Anlagen Verknfüpfung",
    "Linked": "Verbunden",
    "Unlinked": "Nicht verbunden",
    "Main site: ": "Hauptanlage: ",
    "Site Name": "Anlagenname",
    "Site Linked": "Anlage verbunden",
    "unlink charging card": "trenne Ladekarte",
    "Type to filter sites...": "Texteingabe um Anlagen zu filtern...",
    "Charging Card Settings": "Einstellungen Ladekarte",
    "Foreign Card": "Fremdkarte",
    "Delete Card": "Karte löschen",
    "Additional Data": "Zusatzinfo",
    "Generate Pin": "Erzeuge Pin",
    "Card restrictions": "Karten-Einschränkungen",
    "Limit the card to these chargers": "Begrenze die Karte auf diese Ladestationen",
    "Limit the card to chargers": "Begrenze die Karte auf Ladestationen",
    "Limit the card from": "Begrenze die Karte ab",
    "Limit the card until": "Begrenze die Karte bis",
    "Limit the total energy to": "Begrenze die Gesamtenerge auf",
    "every": "pro",
    "Reset Counter": "Zähler zurücksetzen",
    "Limit the total energy": "Begrenze die Gesamtenergie",
    "Limit the total cost to": "Begrenze die Gesamtkosten auf",
    "Limit the total cost": "Begrenze die Gesamtkosten",
    "Limit the charging power to": "Begrenze die Ladeleistung auf",
    "Limit the charging power": "Begrenze die Ladeleistung",
    "Card access": "Karten-Benutzerrechte",
    "Allow login with card": "Login mit Karte",
    "Charger power control": "Ladesteuerung",
    "Vehicle": "Fahrzeug",
    "Vehicle information": "Fahrzeuginformation",
    "Add vehicle information": "Fahrzeuginformation hinzufügen",
    "Identifier": "Bezeichnung",
    "Battery": "Batterie",
    "Energy limit in kWh. You may also set a start date, which is also the start of energy metering for this limit or a period for which this limit applies.": "Energiebegrenzung in kWh. Sie können auch ein Startdatum angeben, welches auch den Start der Energiezählung für diese Begrenzung darstellt oder einen Zeitraum, für den diese Begrenzung gilt.",
    "This resets the counter for the used energy by setting the start date to the current timestamp.": "Dadurch wird der Zähler für die verbrauchte Energie zurückgesetzt, indem das Startdatum auf jetzt gesetzt wird.",
    "Cost limit. You may also set a start date, which is also the start of this cost limit or a period for which this limit applies.": "Kostenbegrenzung. Sie können auch ein Startdatum angeben, welches auch den Start der Kostenberechnung für diese Begrenzung darstellt oder einen Zeitraum, für den diese Begrenzung gilt.",
    "Power limit in kW. You can restrict the maximum charging speed using this value.": "Lastbegrenzung in kW. Sie können damit die maximale Ladeleistung begrenzen.",
    "Checking for valid charger card number...": "Überprüfe für gültige Ladekartennummer...",
    "This charger card number is not valid. It either does not fulfill requirements on card number or is already in use.": "Diese Ladekartennummer ist nicht gültig. Entweder sie ist bereits in Verwendung oder sie erfüllt nicht das notwendige Format.",
    "Card number already in use.": "Ladekarte bereits vergeben.",
    "Generate a valid Pin code for charging stations.": "Erzeuge einen gültigen Pin Code für Ladestationen.",
    "Starting charging session": "Ladevorgang starten",
    "Which user shall be associated to this charging session?": "Welchem Benutzer soll der Ladevorgang zugeordnet werden?",
    "This will start a new charging session and authorize the selected user.": "Hiermit wird ein neuer Ladevorgang gestartet und der ausgewählte Benutzer autorisiert.",
    "Please make sure that the vehicle is ready and already plugged to the charger.": "Bitte stellen Sie sicher, dass das Fahrzeug bereit und an die Ladestation angeschlossen ist.",
    "Select user": "Benutzer auswählen",
    "Tariff Settings": "Tarifeinstellungen",
    "Delete Tariff": "Tarif löschen",
    "Currency": "Währung",
    "If multiple tariffs apply, the tariff with highest priority will be used.": "Bei mehreren passenden Tarifen wird jener mit der höchsten Priorität verwendet.",
    "Costs": "Kosten",
    "Cost per energy": "Kosten pro Energie",
    "Cost per period": "Kosten pro Zeit",
    "Validity Period": "Zeitraum",
    "Limit this tariff from": "Beschränke diesen Tarif von",
    "Limit this tariff until": "Beschränke diesen Tarif bis",
    "The time restriction is:": "Die zeitliche Einschränkung ist:",
    "The time restriction only applies to the start of the charging session. The whole session will be handled like its start.": "Die zeitliche Begrenzung gilt nur für den Beginn des Ladevorgangs. Der gesamte Ladevorgang wird wie dessen Start abgerechnet.",
    "Set a time restriction": "Setze zeitliche Einschränkung",
    "Trend Settings": "Trendeinstellungen",
    "Changing the values of this trend item:": "Ändern der Werte dieses Trend-Datensatzes:",
    "Regulation Period": "Regelungsperiode",
    "Trend Monitor Settings": "Einstellungen Verbrauchsüberwachung",
    "Delete Trend Monitor": "Lösche Verbrauchsüberwachung",
    "Tariff Circuit": "Tarifkreis",
    "value": "Wert",
    "Alarm Tolerance": "Alarm Toleranz",
    "Alarm Slope": "Steigung Alarmgerade",
    "new trend monitor": "neue Überwachung",
    "custom name of trend monitor": "benutzerdefinierter Name der Verbrauchsüberwachung",
    "the tolerance for the target value overshoot alarm": "die Toleranz der Überschreitung des Zielwertes zur Auslösung des Alarms",
    "the tolerance slope for the target value overshoot during the period": "die Toleranzsteigung des Grenzwertes während der Überwachungsperiode",
    "Alarm": "Alarm",
    "Further Information": "Weitere Informationen",
    "No alarms pending.": "Keine Alarme anstehend.",
    "Search for alarms...": "Alarme filtern...",
    "Back to Charger List": "Zurück zu den Ladestationen",
    "Charger List": "Ladestationen",
    "Edit Charger": "Station bearbeiten",
    "Back to Session List": "Zurück zu den Ladevorgängen",
    "Ongoing Charging Session": "Laufender Ladevorgang",
    "Charging Session": "Ladevorgang",
    "Charging Data": "Ladedaten",
    "RESTRICTED CHARGER": "EINGESCHRÄNKTE LADESTATION",
    "Charger model": "Modell",
    "User": "Benutzer",
    "Charging card": "Ladekarte",
    "Start": "Beginn",
    "Transaction ID": "Transaktions-ID",
    "End": "Ende",
    "ongoing": "laufend",
    "Start meter value": "Startzählerstand",
    "End meter value": "Endzählerstand",
    "Stop reason": "Abschluss",
    "Station": "Station",
    "Status Change Events": "Status Ereignisse",
    "Source": "Quelle",
    "Event": "Ereignis",
    "Details": "Details",
    "power limit": "Leistungsgrenze",
    "No charging sessions were found.": "Es wurden keine Ladevorgänge gefunden.",
    "Stop Reason": "Abschluss",
    "User Filter": "Benutzerfilter",
    "refreshing list...": "aktualisiere Liste...",
    "Search failed.": "Suche fehlgeschlagen.",
    "Sum": "Summe",
    "disconnected": "abgesteckt",
    "refused": "abgelehnt",
    "expired": "abgelaufen",
    "other": "anderer",
    "Select Charger": "Ladestation auswählen",
    "Custom Dashboard is not configured for this site.": "Das Kunden-Dashboard ist für diese Anlage nicht konfiguriert.",
    "Realtime Update": "Echtzeit-Aktualisierung",
    "Grid Export": "Netzeinspeisung",
    "Grid Import": "Netzbezug",
    "Battery Storage": "Batteriespeicher",
    "Battery Charging": "Batterie lädt",
    "Battery Discharging": "Batterie entlädt",
    "Photovoltaic": "Photovoltaik",
    "Other": "Andere",
    "Last": "Letzte",
    "Days": "Tage",
    "Today": "Heute",
    "Export": "Einspeisung",
    "Import": "Bezug",
    "No widget selected.": "Keine Anzeige ausgewählt.",
    "Dashboard-Items": "Anzeige-Elemente",
    "Select Dashboard": "Wähle Anzeige",
    "Max. Power": "Max. Leistung",
    "Max. Current": "Max. Strom",
    "Current": "Strom",
    "Session": "Ladevorgang",
    "State": "Zustand",
    "locked": "versperrt",
    "User Administration": "Benutzerverwaltung",
    "Site List": "Anlagenliste",
    "Loading...": "Daten werden geladen...",
    "Create User": "Benutzer anlegen",
    "Save Changes": "Änderungen speichern",
    "Cancel and Back": "Abbrechen und zurück",
    "Back to User Overview": "Zurück zum Benutzer",
    "User name": "Benutzername",
    "Role": "Benutzer",
    "Special access rights": "Besondere Benutzerrechte",
    "Acknowledge Alarms": "Bestätigung Alarme",
    "activate/edit alarms": "Aktivieren/Bearbeiten von Alarmen",
    "Import Trend data": "Verbrauchsdatenimport",
    "Set Virtual Inputs": "Virtuelle Eingänge setzen",
    "Control Outputs": "Steuerung Ausgänge",
    "Update Parameters": "Parameteränderungen",
    "OCPP Change Settings": "OCPP Konfiguration",
    "RFIDs, tariffs, chargers public/private": "RFIDs, Tarife, öffentlich/beschränkte Ladestation",
    "OCPP Administrate Chargers": "OCPP Administration Ladestationen",
    "delete charger, change connector names": "Löschen von Ladestationen, Änderung Anschlussnamen",
    "OCPP Control Chargers": "OCPP Steuerung Ladestationen",
    "start/stop transactions, unlock connector, reboot charger": "Start/Stopp Ladevorgang, Anschluss entriegeln, Neustart Ladestation",
    "access energy management charger data": "Zugriff auf Energiemanagement Ladestationen",
    "Local Controller Admin": "Lokaler Controller Admin",
    "show extended controller data (modules, conditions) and allow reboot": "erweiterte Daten (Module, Bedingungen), Controller Neustarts",
    "create/edit/delete reports": "Erstellen/Bearbeiten/Löschen von Berichten",
    "Trend Monitors": "Verbrauchsüberwachungen",
    "create/edit/delete Trend Monitors": "Erstellen/Bearbeiten/Löschen von Verbrauchsüberwachungen",
    "Access": "Zugriff",
    "Select role": "Rolle auswählen",
    "Search for sites...": "Anlagen filtern...",
    "Click here to see the list of modules and conditions": "Unter folgendem Link können Sie die Liste der Module und Bedingungen anzeigen",
    "Modules and Conditions": "Module und Bedingungen",
    "Switches": "Schaltsignale",
    "Analog": "Analog",
    "Minimum": "Minimum",
    "Maximum": "Maximum",
    "Average": "Mittelwert",
    "No input/output available": "Kein Eingang/Ausgang verfügbar",
    "Select input/output": "Ein-/Ausgang auswählen",
    "Select analog/switch": "Analog-/Schalter auswählen",
    "Select data aggregation": "Daten Aggregierung auswählen",
    "TrendGraphTitle": "Verlauf",
    "TrendTimeGraphTitle": "Schalthandlungen",
    "All items selected": "Alle ausgewählt",
    "Controller Status": "Controller Status",
    "Date and Time": "Datum und Zeit",
    "Software Version": "Software Version",
    "Cloud Status": "Cloud Status",
    "Disabled": "Deaktiviert",
    "Connected": "Verbunden",
    "listener": "Beobachter",
    "Disconnected": "Nicht verbunden",
    "RS485 Bus Load, Controller Temperature": "RS485 Bus Belegung, Controller Temperatur",
    "CPU Load / Free RAM / Free Storage": "CPU Last / freies RAM / Speicher",
    "Reload Site": "Seite Neu Laden",
    "Reboot Controller": "Controller Neu Starten",
    "Power-Off Controller": "Controller Abschalten",
    "IP Configuration": "IP Konfiguration",
    "Hostname": "Hostname",
    "Current IP Addresses": "Aktuelle IP Adressen",
    "Mode": "Modus",
    "Static IP Address": "Statische IP Adresse",
    "Netmask": "Netzmaske",
    "Default Gateway": "Standard Gateway",
    "DNS Server": "DNS Server",
    "IP Settings": "IP Einstellungen",
    "Other Configuration": "Andere Konfiguration",
    "Operator Password": "Operator Passwort",
    "Repeat Operator Password": "Wiederholung Operator Passwort",
    "Cancel Edit": "Editieren abbrechen",
    "Edit Settings": "Einstellungen ändern",
    "Save Settings": "Änderungen speichern",
    "Reboot needed: Please reboot the device after changing the IP configuration.": "Neustart erforderlich: Bitte starten Sie den Controller nach Änderung der IP-Einstellungen neu.",
    "Afterwards wait a few minutes and then reload this web side.": "Warten Sie danach ein paar Minuten und laden Sie anschließend diese Webseite neu.",
    "To modify the settings you need to login as administrator:": "Um die Einstellungen zu ändern müssen Sie sich als Administrator anmelden:",
    "Login": "Anmeldung",
    "Rebooting System": "System Neu Starten",
    "This will perform a reboot of this controller. The energy regulation and recording will not be available during this time. Are you sure?": "Dadurch wird ein Neustart dieses Controllers durchgeführt. Die Energieregelung und -aufzeichnung steht in dieser Zeit nicht zur Verfügung. Sind Sie sicher?",
    "Powering Off System": "System Abschaltung",
    "This will power-off this controller. The controller will be unusable until you disconnect and reconnect its power supply. Are you sure?": "Dadurch wird dieser Controller ausgeschaltet. Der Controller ist außer Betrieb, bis Sie seine Stromversorgung trennen und wieder anschließen. Sind Sie sicher?",
    "Select IP Mode": "Wähle IP Modus",
    "The entered operator passwords are not equal. Aborting change.": "Die eingegebenen operator Passwörter sind nicht gleich. Änderung abgebrochen.",
    "Change Hostname": "Hostname ändern",
    "The hostname may only contain lowercase letters, digits and the hyphen ('-') character. Aborting change.": "Der Hostname darf nur Kleinbuchstaben, Ziffern und den Bindestrich ('-') enthalten. Änderung abgebrochen.",
    "RFID": "RFID",
    "Perform Login": "Anmelden",
    "Forgot Password?": "Passwort vergessen?",
    "Sign-Up here...": "Zur Erstanmeldung...",
    "Hold NFC card to reader.": "Karte an Lesegerät halten.",
    "Scan NFC card": "Lese RFID Karte",
    "This charger card number is not allowed to login.": "Diese Ladekartennummer hat keine Berechtigung zum Einloggen.",
    "Back to Last View": "Zurück zur letzten Ansicht",
    "Click here to see the list of energy meters": "Unter folgendem Link können Sie die Liste der Energiezähler anzeigen",
    "Energy meters": "Energiezähler",
    "Back to report list": "Zurück zur Berichtsliste",
    "Report": "Bericht",
    "Error while loading data": "Fehler beim Laden der Daten",
    "Error while loading report": "Fehler beim Laden des Berichts",
    "Loading Data...": "Lade Daten...",
    "Report Items": "Verfügbare Berichte",
    "Create New": "Erstelle Neu",
    "Report Options": "Berichtsoptionen",
    "Limit period from": "Schränke Zeitraum ein von",
    "Limit period until": "Schränke Zeitraum ein bis",
    "Back to Rfid List": "Zurück zu Ladekarten",
    "Edit Charging Card": "Bearbeite Ladekarte",
    "User Settings": "Benutzereinstellungen",
    "Charger Control Settings": "Einstellungen Ladesteuerung",
    "Varibale Cost Tariff": "Variabler Kostentarif",
    "show tariff in charger power graph": "zeige Kostentarif im Ladeleistungsverlauf",
    "Vehicle Identifier": "Fahrzeugkennung",
    "Vehicle Battery": "Fahrzeugbatterie",
    "This section sets the default settings for the user defined charger power control, which are automatically applied when a new charging session is started.": "In diesem Abschnitt werden die Standardeinstellungen für die benutzerdefinierte Ladeleistungssteuerung festgelegt, die automatisch angewendet werden, wenn ein neuer Ladevorgang gestartet wird.",
    "The settings can be adapted then for each running charging.session.": "Die Einstellungen können dann für jeden laufenden Ladevorgang angepasst werden.",
    "Connect to Site": "Verbindung zur Anlage herstellen",
    "Currently, you are not connected to a site.": "Derzeit sind Sie mit keiner Anlage verbunden.",
    "You need to connect to the site to see live data or to make any changes.": "Sie müssen eine Verbindung zur Anlage herstellen, um Live-Daten anzuzeigen oder Änderungen vorzunehmen.",
    "Please select the site you want to monitor.": "Bitte wählen Sie die Anlage, die Sie ansehen möchten.",
    "Connect": "Verbinden",
    "Favorites": "Favoriten",
    "Loading the list of available sites. Please wait.": "Die Liste der verfügbaren Anlagen wird geladen. Bitte warten.",
    "Currently, there is no site available, which you can connect to.": "Aktuell existieren keine Anlagen, zu denen Sie sich verbinden können.",
    "Please contact the system administrator to assign a site to your user.": "Bitte kontaktieren Sie den Administrator um Ihnen Anlagen zuzuweisen.",
    "You are connected to this site:": "Sie sind mit dieser Anlage verbunden:",
    "Serial": "Seriennummer",
    "Trend / Live Data": "Trend / Live Daten",
    "Disconnect": "Trennen",
    "Connect Offline": "Offline Verbinden",
    "Site Settings": "Einstellungen",
    "Select site": "Anlage auswählen",
    "Favorite": "Favorit",
    "Site Administration": "Anlageneinstellungen",
    "Back to Site Selection": "Zurück zur Anlagenauswahl",
    "Execution Pending": "Ausführung läuft",
    "Open SSH Tunnel": "Öffne SSH Tunnel",
    "Import Trend Data": "Import Verbrauchsdaten",
    "This will open an SSH tunnel to the embyt server, which stays active for one hour. Connect via ssh -p 43022 embyt@enl-tun.embyt.com. Are you sure?": "Dadurch wird ein SSH-Tunnel zum embyt-Server geöffnet, der eine Stunde lang aktiv bleibt. Verbinden Sie sich über ssh -p 43022 embyt@enl-tun.embyt.com. Sind Sie sicher?",
    "This will reboot the enline controller, which will stop energy regulation and may last several minutes. Are you sure?": "Dadurch wird der Enline-Controller neu gestartet, was die Energieregulierung stoppt und mehrere Minuten dauern kann. Sind Sie sicher?",
    "Back to Timeseries": "Zurück zur Zeitreihe",
    "Current User": "Aktueller Benutzer",
    "The following user is currently logged into this website.": "Der folgende Benutzer ist aktuell angemeldet.",
    "Charging Card": "Ladekarte",
    "Logout": "Abmelden",
    "Settings": "Einstellungen",
    "You have the access right to administrate other users.": "Sie haben die Rechte zur Verwaltung anderer Benutzer.",
    "Please select the user to modify in the drop-down box below and press modify afterwards.": "Bitte wählen Sie den Benutzer in der Auswahlbox und betätigen Sie danach Bearbeiten.",
    "Modify": "Bearbeiten",
    "To add a new user press the create button below.": "Um einen neuen Benutzer anzulegen betätigen Sie Anlegen."
  }
};

export default LOCALES;
